<template>
    <div class="col-md-12">
        <div class="flash-message">
            <FlashMessage :position="'top'"></FlashMessage>
        </div>
        <form @submit.prevent="updateBooking">
            <div class="container-fluid bg-light py-3">
                <div class="row">
                    <div class="col-md-6">
                        <div class="h2"> #B-{{ booking.id }} ({{ types[booking.type] }}) - {{ booking.client }} - {{ booking.dropoff_address.name }}
                            <span v-if="booking.recurring_data">
                                          ({{ booking.recurring_data.name }})
                            </span>
                        </div>
                        <div v-if="booking.original_booking_id" class="h3">
                            Copy:
                            <a :href="`/bookings/${booking.original_booking_id}/edit`">
                                #B-{{ booking.original_booking_id }}-{{ booking.copy }}
                            </a>
                        </div>
                        <div class="my-2">
                            <div class="rebooking" v-if="booking.rebooking_from">
                                Rebooking of booking {{ booking.rebooking_from }}
                            </div>
                            <div class="rebooking" v-if="booking.rebooking_to">
                                Rebooked in booking {{ booking.rebooking_to }}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 d-flex justify-content-left align-items-left">
                                <div class="btn-group status-icons float-right shadow-sm" role="group" aria-label="">
                                    <div
                                        class="btn  d-flex align-items-center float-left status-block status-text"
                                        :class="booking.status_id===1 ? 'status-block status-text border-bottom-status' : 'status-block-inactive status-text-inactive'"
                                    >
                                                   <span class="material-icons-outlined cursor-pointer mr-1"
                                                         title="person_add">person_add</span>
                                        <span class="status-label">New</span>
                                    </div>


                                    <div
                                        class="btn  d-flex align-items-center float-left status-block status-text"
                                        :class="booking.status_id===2 ? 'status-block status-text border-bottom-status' : 'status-block-inactive status-text-inactive'"
                                    >
                                                  <span class="material-icons-outlined cursor-pointer mr-1"
                                                        title="done">done</span>
                                        <span class="status-label">Confirmed</span>
                                    </div>

                                    <div v-if="booking.is_booking_pickup_exists===true"
                                         class="btn  d-flex align-items-center float-left status-block status-text"
                                         :class="booking.status_id===3 ? 'status-block status-text border-bottom-status' : 'status-block-inactive status-text-inactive'"
                                    >
                                        <span class="material-icons-outlined cursor-pointer mr-1"
                                              title="done">archive</span>
                                        <span class="status-label">Ready for pickup</span>
                                    </div>


                                    <div v-if="booking.is_booking_pickup_exists===true"
                                         class="btn  d-flex align-items-center float-left status-block status-text"
                                         :class="booking.status_id===5 ? 'status-block status-text border-bottom-status' : 'status-block-inactive status-text-inactive'"
                                    >
                                              <span class="material-icons-outlined cursor-pointer mr-1"
                                                    title="done">local_shipping</span>
                                        <span class="status-label">On pickup</span>
                                    </div>

                                    <div v-if="booking.is_booking_linehaul_exists===true"
                                         class="btn  d-flex align-items-center float-left status-block status-text"
                                         :class="booking.status_id===6 ? 'status-block status-text border-bottom-status' : 'status-block-inactive status-text-inactive'"
                                    >
                                              <span class="material-icons-outlined cursor-pointer mr-1"
                                                    title="done">flight_takeoff</span>
                                        <span class="status-label">Awaiting linehaul</span>
                                    </div>

                                    <div v-if="booking.is_booking_dropoff_exists===true"
                                         class="btn  d-flex align-items-center float-left status-block status-text"
                                         :class="booking.status_id===7 ? 'status-block status-text border-bottom-status' : 'status-block-inactive status-text-inactive'"
                                    >
                                        <span class="material-icons-outlined cursor-pointer mr-1"
                                              title="done">unarchive</span>
                                        <span class="status-label">Ready for delivery</span>
                                    </div>

                                    <div v-if="booking.is_booking_dropoff_exists===true"
                                         class="btn  d-flex align-items-center float-left status-block status-text"
                                         :class="booking.status_id===9 ? 'status-block status-text border-bottom-status' : 'status-block-inactive status-text-inactive'"
                                    >
                                              <span class="material-icons-outlined cursor-pointer mr-1"
                                                    title="done"> local_shipping</span>
                                        <span class="status-label">On delivery</span>
                                    </div>

                                    <div v-if="booking.status_id !== 11 && booking.status_id !== 12">
                                        <div
                                            class="btn  d-flex align-items-center float-left status-block status-text"
                                            :class="booking.status_id===10 ? 'status-block status-text border-bottom-status' : 'status-block-inactive status-text-inactive'"
                                        >
                                            <span class="material-icons-outlined cursor-pointer mr-1"
                                                  title="done">verified</span>
                                            <span class="status-label">Delivered</span>
                                        </div>
                                    </div>
                                    <div
                                        v-else-if="booking.status_id === 11"
                                        class="btn  d-flex align-items-center float-left status-block status-block-error status-text"
                                    >
                                        <span class="material-icons-outlined cursor-pointer mr-1"
                                              title="done">cancel</span>
                                        <span class="status-label">Failed</span>
                                    </div>
                                    <div
                                        v-else-if="booking.status_id === 12"
                                        class="btn  d-flex align-items-center float-left status-block status-block-error status-text"
                                    >
                                        <span class="material-icons-outlined cursor-pointer mr-1"
                                              title="done">cancel</span>
                                        <span class="status-label">Rejected</span>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="booking.status_id === 11"
                                class="mt-4 ml-3 btn add-warehouse btn-success"
                                @click="redirectToCreateRebookingPage">
                                Create rebooking
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2" v-if="booking.depends_on || booking.child_booking">
                        <div class="p-4 mb-0 bg-white rounded-lg">
                            <div class="d-flex justify-content-between align-items-center pb-2 border-bottom ">
                                <div class="h3 mb-0">Connected booking</div>
                            </div>
                            <div class="font-weight-semi-bold">
                                <div v-if="booking.depends_on">
                                    <a :href="`/bookings/${booking.depends_on}/edit`" class="invisible-link">
                                        #B-{{ booking.depends_on }}
                                    </a>
                                </div>
                                <div v-if="booking.child_booking">
                                    <a :href="`/bookings/${booking.child_booking}/edit`" class="invisible-link">
                                        #B-{{ booking.child_booking }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2" v-if="!booking.depends_on && !booking.child_booking">

                    </div>
                    <div class="col-md-2">
                        <div class="p-4 mb-0 bg-white rounded-lg" v-if="role !== roleUser">
                            <div v-if="booking.booking_type == 2 || booking.is_recurring == 1">
                                <div class="d-flex justify-content-between align-items-center pb-2 border-bottom ">
                                    <div class="h3 mb-0">External driver</div>
                                    <a @click="isEditingExternalDriver= !isEditingStatus"
                                       v-if="!isEditingExternalDriver && canEdit">
                                        <span class="material-icons-outlined cursor-pointer text-primary">edit</span>
                                    </a>
                                    <a class="cursor-pointer" v-if="isEditingExternalDriver"
                                       @click="isEditingExternalDriver = false">
                                        <small>cancel editing</small>
                                    </a>
                                </div>
                                <div v-if="isEditingExternalDriver">
                                    <div class="form-group">
                                        <div class="align-items-center bg-white rounded-lg div-focus">
                                            <v-select
                                                :options="driverList"
                                                v-model="booking.driver"
                                                :clearSearchOnSelect="false"
                                                label="name"
                                                id="driver-name">
                                            </v-select>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="form-group">
                                        <div>
                                            <span>Driver: </span> <span class="font-weight-semi-bold">{{

                                                booking.driver ? booking.driver.name : ''
                                            }} </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="role !== roleUser"
                                 class="btn btn-success mt-3"
                                 @click="changeBookingTypeModal">
                                <i title="Change booking type"></i> Change booking type
                            </div>
                            <div v-if="role !== roleUser"
                                 class="btn btn-success mt-3"
                                 @click="toggleModalCopyBooking"
                            >
                                Copy booking
                            </div>
                            <div class="mt-3" v-if="booking.copies && booking.copies.length">
                                <div class="h3 mb-0">Copies:</div>
                                <div v-for="copy in booking.copies">
                                    {{ copy.copy }}:
                                    <a :href="`/bookings/${copy.id}/edit`">
                                        #B-{{ copy.id }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-2">
                        <div class="p-4 mb-0 bg-white rounded-lg">
                            <div class="d-flex justify-content-between align-items-center pb-2 border-bottom ">
                                <div class="h3 mb-0">Status</div>
                                <a @click="isEditingStatus = !isEditingStatus"
                                   v-if="!isEditingStatus && role !== 'user'">
                                    <span class="material-icons-outlined cursor-pointer text-primary">edit</span>
                                </a>
                                <a class="cursor-pointer" v-if="isEditingStatus" @click="isEditingStatus = false">
                                    <small>cancel editing</small>
                                </a>
                            </div>
                            <div class="form-group">
                                <div v-if="isEditingStatus"
                                     :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingStatus, '': booking.status_id==='' && isSubmit}">
                                    <select required
                                            class="form-control border-0 py-0 shadow-none pr-5"
                                            :disabled="!isEditingStatus"
                                            :class="{view: !isEditingStatus}"
                                            v-model="booking.status_id">
                                        <option value="1">New</option>
                                        <option value="2">Confirmed</option>
                                        <option value="3" v-if="booking.is_booking_pickup_exists===true">Awaiting
                                            pickup
                                        </option>
                                        <option value="5" v-if="booking.is_booking_pickup_exists===true">On pickup
                                        </option>
                                        <option value="6" v-if="booking.is_booking_linehaul_exists===true">Awaiting
                                            linehaul
                                        </option>
                                        <option value="7" v-if="booking.is_booking_dropoff_exists===true">Ready for
                                            delivery
                                        </option>
                                        <option value="9" v-if="booking.is_booking_dropoff_exists===true">On dropoff
                                        </option>
                                        <option value="10">Delivered</option>
                                    </select>
                                </div>
                                <div v-else class="font-weight-semi-bold">
                                    {{ booking.status }}
                                </div>
                            </div>
                        </div>
                        <div class="p-4 mt-2 mb-0 bg-white rounded-lg" v-if="!booking.is_delivery_from_warehouse && role !== 'user'">
                            <div class="h3 mb-1">Send SMS</div>
                            <div class="dropdown">
                                <button type="button" class="btn btn-primary btn-dropdown"
                                        id="dropdownSendEmail" data-toggle="dropdown" aria-haspopup="true"
                                        aria-expanded="false">
                                    SMS type
                                    <span class="vertical-align-middle pr-2 material-icons-outlined">sms</span>
                                </button>
                                <div class="dropdown-menu" aria-labelledby="dropdownSendEmail">
                                    <span class="dropdown-item cursor-pointer" v-for="smsTemplate in smsTemplates"
                                       @click="smsSend(smsTemplate)">
                                        {{ smsTemplate.title }}
                                    </span>
                                </div>
                            </div>
                            <div>
                                <div v-if="!booking.dropoff_address.phone"
                                     class="d-flex align-items-top justify-content-between mt-1"
                                >
                                    <span class="material-symbols-outlined text-primary">warning</span>
                                    <span>&nbsp;Phone is missing in the delivery address.</span>
                                </div>
                                <div v-if="!booking.dropoff_date || booking.dropoff_date === '0000-00-00'"
                                     class="d-flex align-items-top justify-content-between mt-1"
                                >
                                    <span class="material-symbols-outlined text-primary">warning</span>
                                    <span>&nbsp;Delivery date is invalid</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div v-for="(errorArray, idx) in validationErrors" :key="idx">
                        <div v-for="(allErrors, idx) in errorArray" :key="idx">
                            <span class="text-danger">{{ allErrors }} </span> <br/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container-fluid bg-light py-3">
                <div class="row">

                    <div class="col-3">
                        <div class="card mb-4 box-shadow h-100">
                            <div class="card-body">
                                <div class="p-4 mb-0 bg-white rounded-lg">
                                    <div class="d-flex justify-content-between align-items-center pb-2 border-bottom ">
                                        <div class="h3 mb-0">Pickup Address</div>
                                        <div>
                                            <a class="d-flex align-items-center text-decoration-none"
                                               @click="isEditingPickup = !isEditingPickup"
                                               v-if="!isEditingPickup && !booking.deleted_at && canEdit">
                                                <span
                                                    class="material-icons-outlined cursor-pointer text-primary">edit</span>
                                            </a>
                                            <a v-if="isEditingPickup" @click="isEditingPickup = false"
                                               class="text-decoration-none text-decoration-none">
                                                <small>cancel editing</small>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="pt-3">
                                        <div v-if="isEditingPickup">
                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold">Name</label>
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingPickup, 'border-danger': booking.pickup_address.name==='' && isSubmit}">
                                                    <input type="text"
                                                           autocomplete="off"
                                                           required
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           v-model="booking.pickup_address.name"
                                                           :disabled="!isEditingPickup"
                                                           :class="{view: !isEditingPickup}">
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold">Address</label>
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingPickup, 'border-danger': booking.pickup_address.street==='' && isSubmit}">
                                                    <input type="text"
                                                           autocomplete="off"
                                                           required
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           v-model="booking.pickup_address.street"
                                                           :disabled="!isEditingPickup"
                                                           :class="{view: !isEditingPickup}">
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <div class="form-group row">
                                                    <div class="col-md-4">
                                                        <label class="d-block mb-0 font-weight-bold">Zip</label>
                                                        <div
                                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingPickup, 'border-danger': booking.pickup_address.zip==='' && isSubmit}">
                                                            <input type="text"
                                                                   autocomplete="off"
                                                                   required
                                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                                   v-model="booking.pickup_address.zip"
                                                                   :disabled="!isEditingPickup"
                                                                   :class="{view: !isEditingPickup}">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-8">
                                                        <label class="d-block mb-0 font-weight-bold">City</label>
                                                        <div
                                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingPickup, 'border-danger': booking.pickup_address.city==='' && isSubmit}">
                                                            <input type="text"
                                                                   required
                                                                   autocomplete="off"
                                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                                   v-model="booking.pickup_address.city"
                                                                   :disabled="!isEditingPickup"
                                                                   :class="{view: !isEditingPickup}">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold">Country</label>
                                                <div
                                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                                    <select class="form-control"
                                                            v-model="booking.pickup_address.country_id">
                                                        <option v-for="item in countryList" :value="item.id">
                                                            {{ item.name }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold">Phone</label>
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingPickup, 'border-danger': booking.pickup_address.phone==='' && isSubmit}">
                                                    <input type="text"
                                                           autocomplete="off"
                                                           placeholder="phone"
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           v-model="booking.pickup_address.phone"
                                                           :disabled="!isEditingPickup"
                                                           :class="{view: !isEditingPickup}">
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold">Email</label>
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingPickup}">
                                                    <input type="text"
                                                           autocomplete="off"
                                                           placeholder="email"
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           v-model="booking.pickup_email"
                                                           :disabled="!isEditingPickup"
                                                           :class="{view: !isEditingPickup}">
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold">Date</label>
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingPickup, 'border-danger': booking.pickup_date==='' && isSubmit}">
                                                    <input type="date"
                                                           name="pickup_date"
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           v-model="booking.pickup_date"
                                                           :disabled="!isEditingPickup"
                                                           :class="{view: !isEditingPickup}">
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <div class="col-md-6">
                                                    <label class="d-block mb-0 font-weight-bold" for="pickup-start">
                                                        Time start
                                                    </label>
                                                    <div
                                                        :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingPickup, 'border-danger': booking.pickup_start==='' && isSubmit}">
                                                        <input type="time"
                                                               id="pickup-start"
                                                               class="form-control border-0 py-0 shadow-none form-input"
                                                               placeholder="time start"
                                                               v-model="booking.pickup_start"
                                                               :disabled="!isEditingPickup"
                                                               :class="{view: !isEditingPickup}">
                                                        <div class="help-block with-errors"></div>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <label class="d-block mb-0 font-weight-bold" for="pickup-end">
                                                        Time end
                                                    </label>
                                                    <div
                                                        :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingPickup, 'border-danger': booking.pickup_end==='' && isSubmit}">
                                                        <input type="time"
                                                               id="pickup-end"
                                                               class="form-control border-0 py-0 shadow-none form-input"
                                                               v-model="booking.pickup_end"
                                                               placeholder="time end"
                                                               :disabled="!isEditingPickup"
                                                               :class="{view: !isEditingPickup}">
                                                        <div class="help-block with-errors"></div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <div class="col-md-6">
                                                    <label class="d-block mb-0 font-weight-bold" for="pickup-delivered-start">
                                                        Delivered start
                                                    </label>
                                                    <div>
                                                        {{ booking.pickup_delivered_start }}
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <label class="d-block mb-0 font-weight-bold" for="pickup-delivered-end">
                                                        Delivered end
                                                    </label>
                                                    <div>
                                                        {{ booking.pickup_delivered_end }}
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold">Note</label>
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingPickup, 'border-danger': booking.pickup_note==='' && isSubmit}">
                                                    <input type="text"
                                                           autocomplete="off"
                                                           placeholder="note"
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           v-model="booking.pickup_note"
                                                           :disabled="!isEditingPickup"
                                                           :class="{view: !isEditingPickup}">
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else>
                                            {{ booking.pickup_address.name }} <br>
                                            {{ booking.pickup_address.street }},
                                            {{ booking.pickup_address.zip }}
                                            {{ booking.pickup_address.city }},
                                            {{
                                            booking.pickup_address.country ? booking.pickup_address.country.name :
                                            'Denmark'
                                            }}
                                            <br>
                                            {{ booking.pickup_address.phone }} <br>
                                            {{ booking.pickup_email }} <br>
                                            <div class="d-flex align-items-center">
                                                <span
                                                    class="material-icons-outlined small cursor-pointer pr-1">event</span>
                                                <span>{{ formatDate(booking.pickup_date) }}</span>
                                            </div>
                                            <div class="d-flex align-items-center">
                                                <span
                                                    class="material-icons-outlined cursor-pointer pr-1">schedule</span>
                                                <span>{{ booking.pickup_start }} - {{ booking.pickup_end }}</span>
                                            </div>
                                            <div class="d-flex align-items-center">
                                                <span class="material-symbols-outlined pr-1">local_shipping</span>
                                                <span>
                                                    {{ booking.pickup_delivered_start }} -
                                                    {{ booking.pickup_delivered_end }}
                                                </span>
                                            </div>
                                            {{ booking.pickup_note }}
                                        </div>
                                        <br>
                                        <br>
                                        <div class="custom-control custom-checkbox mb-3"
                                             v-if="hasSpecialPermission('can_edit_time_communicated') && booking.pickup_trip">
                                            <input type="checkbox" class="custom-control-input"
                                                   id="pickup_time_communicated"
                                                   v-model="booking.pickup_trip.time_communicated">
                                            <label class="custom-control-label" for="pickup_time_communicated">
                                                <b>Time communicated:</b>
                                            </label>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-3">
                        <div class="card mb-4 box-shadow h-100">
                            <div class="card-body">
                                <div class="p-4 mb-0 bg-white rounded-lg">
                                    <div class="d-flex justify-content-between align-items-center pb-2 border-bottom">
                                        <div class="h3 mb-0">Delivery Address</div>
                                        <div>
                                            <a class="d-flex align-items-center text-decoration-none"
                                               @click="isEditingDropoff = !isEditingDropoff"
                                               v-if="!isEditingDropoff && !booking.deleted_at && canEdit">
                                                <span
                                                    class="material-icons-outlined cursor-pointer text-primary">edit</span>
                                            </a>
                                            <a v-if="isEditingDropoff" @click="isEditingDropoff = false"
                                               class="text-decoration-none">
                                                <small>cancel editing</small>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="pt-3">

                                        <div v-if="isEditingDropoff">
                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold">Name</label>
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingDropoff, 'border-danger': booking.dropoff_address.name==='' && isSubmit}">
                                                    <input type="text"
                                                           autocomplete="off"
                                                           required
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           v-model="booking.dropoff_address.name"
                                                           :disabled="!isEditingDropoff"
                                                           :class="{view: !isEditingDropoff}">
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold">Address</label>
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingDropoff, 'border-danger': booking.dropoff_address.street==='' && isSubmit}">
                                                    <input type="text"
                                                           autocomplete="off"
                                                           required
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           v-model="booking.dropoff_address.street"
                                                           :disabled="!isEditingDropoff"
                                                           :class="{view: !isEditingDropoff}">
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <div class="form-group row">
                                                    <div class="col-md-4">
                                                        <label class="d-block mb-0 font-weight-bold">Zip</label>
                                                        <div
                                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingDropoff, 'border-danger': booking.dropoff_address.zip==='' && isSubmit}">
                                                            <input type="text"
                                                                   autocomplete="off"
                                                                   required
                                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                                   v-model="booking.dropoff_address.zip"
                                                                   :disabled="!isEditingDropoff"
                                                                   :class="{view: !isEditingDropoff}">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-8">
                                                        <label class="d-block mb-0 font-weight-bold">City</label>
                                                        <div
                                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingDropoff, 'border-danger': booking.dropoff_address.city==='' && isSubmit}">
                                                            <input type="text"
                                                                   required
                                                                   autocomplete="off"
                                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                                   v-model="booking.dropoff_address.city"
                                                                   :disabled="!isEditingDropoff"
                                                                   :class="{view: !isEditingDropoff}">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold">Country</label>
                                                <div
                                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                                    <select class="form-control"
                                                            v-model="booking.dropoff_address.country_id">
                                                        <option v-for="item in countryList" :value="item.id">
                                                            {{ item.name }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold">Phone</label>
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingDropoff, 'border-danger': booking.dropoff_address.phone==='' && isSubmit}">
                                                    <input type="text"
                                                           autocomplete="off"
                                                           placeholder="phone"
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           v-model="booking.dropoff_address.phone"
                                                           :disabled="!isEditingDropoff"
                                                           :class="{view: !isEditingDropoff}">
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold">Email</label>
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingDropoff}">
                                                    <input type="text"
                                                           autocomplete="off"
                                                           placeholder="email"
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           v-model="booking.dropoff_email"
                                                           :disabled="!isEditingDropoff"
                                                           :class="{view: !isEditingDropoff}">
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold">Date</label>
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingDropoff, 'border-danger': booking.dropoff_date==='' && isSubmit}">
                                                    <input type="date"
                                                           name="dropoff_date"
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           v-model="booking.dropoff_date"
                                                           :disabled="!isEditingDropoff"
                                                           :class="{view: !isEditingDropoff}">
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <div class="col-md-6">
                                                    <label class="d-block mb-0 font-weight-bold" for="dropoff-start">
                                                        Time start
                                                    </label>
                                                    <div
                                                        :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingDropoff, 'border-danger': booking.dropoff_start==='' && isSubmit}">
                                                        <input type="time"
                                                               id="dropoff-start"
                                                               class="form-control border-0 py-0 shadow-none form-input"
                                                               placeholder="time start"
                                                               v-model="booking.dropoff_start"
                                                               :disabled="!isEditingDropoff"
                                                               :class="{view: !isEditingDropoff}">
                                                        <div class="help-block with-errors"></div>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <label class="d-block mb-0 font-weight-bold" for="dropoff-end">
                                                        Time end
                                                    </label>
                                                    <div
                                                        :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingDropoff, 'border-danger': booking.dropoff_end==='' && isSubmit}">
                                                        <input type="time"
                                                               id="dropoff-end"
                                                               class="form-control border-0 py-0 shadow-none form-input"
                                                               v-model="booking.dropoff_end"
                                                               placeholder="time end"
                                                               :disabled="!isEditingDropoff"
                                                               :class="{view: !isEditingDropoff}">
                                                        <div class="help-block with-errors"></div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <div class="col-md-6">
                                                    <label class="d-block mb-0 font-weight-bold" for="dropoff-delivered-start">
                                                        Delivered start
                                                    </label>
                                                    <div>
                                                        {{ booking.dropoff_delivered_start }}
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <label class="d-block mb-0 font-weight-bold" for="dropoff-delivered-end">
                                                        Delivered end
                                                    </label>
                                                    <div>
                                                        {{ booking.dropoff_delivered_end }}
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold">Note</label>
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingDropoff, 'border-danger': booking.dropoff_note==='' && isSubmit}">
                                                    <input type="text"
                                                           autocomplete="off"
                                                           placeholder="note"
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           v-model="booking.dropoff_note"
                                                           :disabled="!isEditingDropoff"
                                                           :class="{view: !isEditingDropoff}">
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else>
                                            {{ booking.dropoff_address.name }} <br>
                                            {{ booking.dropoff_address.street }},
                                            {{ booking.dropoff_address.zip }}
                                            {{ booking.dropoff_address.city }},

                                            {{

                                            booking.dropoff_address.country ? booking.dropoff_address.country.name :
                                            'Denmark'
                                            }}

                                            <br>
                                            {{ booking.dropoff_address.phone }} <br>
                                            {{ booking.dropoff_email }} <br>

                                            <div class="d-flex align-items-center">
                                                <span
                                                    class="material-icons-outlined small cursor-pointer pr-1">event</span>
                                                <span>{{ formatDate(booking.dropoff_date) }}</span>
                                            </div>
                                            <div class="d-flex align-items-center">
                                                <span
                                                    class="material-icons-outlined cursor-pointer pr-1">schedule</span>
                                                <span>{{ booking.dropoff_start }} - {{ booking.dropoff_end }}</span>
                                            </div>
                                            <div class="d-flex align-items-center">
                                                <span class="material-symbols-outlined pr-1">local_shipping</span>
                                                <span>
                                                    {{ booking.dropoff_delivered_start }} -
                                                    {{ booking.dropoff_delivered_end }}
                                                </span>
                                            </div>
                                            {{ booking.dropoff_note }}
                                        </div>
                                        <br/>
                                        <br/>
                                        <div class="custom-control custom-checkbox mb-3"
                                             v-if="hasSpecialPermission('can_edit_time_communicated') && booking.dropoff_trip">
                                            <input type="checkbox" class="custom-control-input"
                                                   id="dropoff_time_communicated"
                                                   v-model="booking.dropoff_trip.time_communicated">
                                            <label class="custom-control-label" for="dropoff_time_communicated">
                                                <b>Time communicated:</b>
                                            </label>
                                        </div>
                                        <div class="custom-control custom-checkbox mb-3">
                                            <input type="checkbox" class="custom-control-input"
                                                   id="is_delivery_from_warehouse"
                                                   v-model="booking.is_delivery_from_warehouse">
                                            <label class="custom-control-label" for="is_delivery_from_warehouse">
                                                <b>Delivery from warehouse:</b></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-3">
                        <div class="card mb-4 box-shadow h-100">
                            <div class="card-body">
                                <div class="p-4 mb-0 bg-white rounded-lg">
                                    <div class="d-flex justify-content-between align-items-center pb-2 border-bottom ">
                                        <div class="h3 mb-0">Rekv. number</div>
                                        <div>
                                            <a @click="isEditingNote = !isEditingNote"
                                               v-if="!isEditingNote && !booking.deleted_at && canEdit">
                                                <span
                                                    class="material-icons-outlined cursor-pointer text-primary">edit</span>
                                            </a>
                                            <a v-if="isEditingNote" @click="isEditingNote = false">
                                                <small>cancel editing</small>
                                            </a>
                                        </div>

                                    </div>
                                    <div class="pt-3">
                                        <div class="form-group" v-if="booking.note && !isEditingNote">
                                            <label class="d-block mb-0 font-weight-bold">Note:</label>
                                            <div>
                                                {{ booking.note }}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label class="d-block mb-0 font-weight-bold">Reference:</label>
                                            <div v-if="!isEditingNote">
                                                {{ booking.reference }}
                                            </div>
                                            <div v-else
                                                 :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingNote, 'border-danger': booking.reference==='' && isSubmit}">
                                                <input type="text"
                                                       autocomplete="off"
                                                       class="form-control  border-0 py-0 shadow-none form-input"
                                                       placeholder="reference"
                                                       v-model="booking.reference" :disabled="!isEditingNote"
                                                       :class="{view: !isEditingNote}">
                                                <div class="help-block with-errors"></div>
                                            </div>
                                        </div>

                                        <div class="form-group" v-if="bookingPermits.length">
                                            <label class="d-block mb-0 font-weight-bold" for="permits">Fuldmagt:</label>
                                            <div v-for="permit in bookingPermits">
                                                {{ permit }}
                                            </div>
<!--                                            <div class="align-items-center bg-white border rounded-lg div-focus" v-else>-->
<!--                                                <v-select-->
<!--                                                    :options="availablePermits"-->
<!--                                                    v-model="booking.customer_options[permitsKey].value"-->
<!--                                                    id="permits"-->
<!--                                                >-->
<!--                                                </v-select>-->
<!--                                                <div class="help-block with-errors"></div>-->
<!--                                            </div>-->
                                        </div>

                                        <div class="form-group">
                                            <div v-if="booking.pickup_trip && booking.pickup_trip.image">
                                                <div v-for="(image, index) in getImageArray(booking.pickup_trip.image)"
                                                     :key="index"
                                                     class="d-flex justify-content-between"><span>Pickup trip PoD:</span>
                                                    <div>
                                                        <a class="btn btn-info btn-sm pod-button"
                                                           @click="downloadPod(image, booking.pickup_trip.id, fileTypeImage, index)">
                                                            Download PoD
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>

                                            <div v-if="booking.pickup_trip && booking.pickup_trip.signature"
                                                 class="d-flex justify-content-between"><span>Pickup trip PoD:</span>
                                                <div><a
                                                    class="btn btn-info btn-sm pod-button"
                                                    @click="downloadPod(booking.pickup_trip.signature, booking.pickup_trip.id, fileTypeSignature)">
                                                    Download PoD
                                                </a>
                                                </div>
                                            </div>
                                            <div v-if="booking.pickup_trip && booking.pickup_trip.signature && booking.pickup_trip.image"
                                                 class="d-flex justify-content-between"><span>Pickup trip complete PoD:</span>
                                                <!-- @todo downloadCompletePod   -->
                                                <div><a
                                                    class="btn btn-info btn-sm pod-button"
                                                    @click="downloadCompletePod(booking.pickup_trip.id)">
                                                    Download PoD
                                                </a>
                                                </div>
                                            </div>
                                            <div v-if="booking.dropoff_trip && booking.dropoff_trip.image">
                                                <div v-for="(image, index) in getImageArray(booking.dropoff_trip.image)"
                                                     :key="index"
                                                     class="d-flex justify-content-between"><span>Dropoff trip PoD:</span>
                                                    <div>
                                                        <a class="btn btn-info btn-sm pod-button"
                                                           @click="downloadPod(image, booking.dropoff_trip.id, fileTypeImage, index)">
                                                            Download PoD
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="booking.dropoff_trip &&  booking.dropoff_trip.signature"
                                                 class="d-flex justify-content-between"><span>Dropoff trip PoD:</span>
                                                <div><a
                                                    class="btn btn-info btn-sm pod-button"
                                                    @click="downloadPod(booking.dropoff_trip.signature, booking.dropoff_trip.id,fileTypeSignature)">
                                                    Download PoD
                                                </a>
                                                </div>
                                            </div>
                                            <div v-if="booking.dropoff_trip && booking.dropoff_trip.signature && booking.dropoff_trip.image"
                                                 class="d-flex justify-content-between"><span>Dropoff trip complete PoD:</span>
                                                <div><a
                                                    class="btn btn-info btn-sm pod-button"
                                                    @click="downloadCompletePod(booking.dropoff_trip.id)">
                                                    Download PoD
                                                </a>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-3">
                        <div class="card mb-4 box-shadow h-100">
                            <div class="card-body">
                                <div class="p-4 mb-0 bg-white rounded-lg"
                                     :class="booking.status_id===1 && (booking.product_price==='' || booking.product_price===0)? 'border border-danger border-width-3':''"
                                >
                                    <div class="d-flex justify-content-between align-items-center pb-2 border-bottom">
                                        <div class="h3 mb-0">Colli</div>
                                    </div>
                                    <div class="pt-3">
                                        <b> Total Volume (m3)</b> <br/>
                                        <div class="form-group">
                                            <div
                                                :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingColli, 'border-danger': booking.volume==='' && isSubmit}">
                                                <input type="text"
                                                       autocomplete="off"
                                                       required
                                                       class="form-control  border-0 py-0 shadow-none form-input"
                                                       placeholder="volume"
                                                       v-model="booking.volume"
                                                       :disabled=true
                                                       :class="{view: !isEditingColli}">
                                                <div class="help-block with-errors"></div>
                                            </div>
                                        </div>
                                        <b> Total Weight (kg)</b> <br/>
                                        <div class="form-group">
                                            <div
                                                :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingColli, 'border-danger': booking.weight==='' && isSubmit}">
                                                <input type="text"
                                                       autocomplete="off"
                                                       required
                                                       class="form-control  border-0 py-0 shadow-none form-input"
                                                       placeholder="weight"
                                                       v-model="booking.weight"
                                                       :disabled=true
                                                       :class="{view: !isEditingColli}">
                                                <div class="help-block with-errors"></div>
                                            </div>
                                        </div>
                                        <b> Total Colli (m3)</b> <br/>
                                        <div class="form-group">

                                            <div
                                                :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingColli, 'border-danger': booking.colli==='' && isSubmit}">
                                                <input type="text"
                                                       autocomplete="off"
                                                       class="form-control  border-0 py-0 shadow-none form-input"
                                                       placeholder="colli"
                                                       v-model="booking.colli"
                                                       :disabled=true
                                                       :class="{view: !isEditingColli}">
                                                <div class="help-block with-errors"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

            <div class="container-fluid bg-light py-3">
                <div class="row">

                    <div class="col-md-6">
                        <div class="card mb-4 box-shadow h-100">
                            <div class="card-body">
                                <div class="p-4 mb-0 bg-white rounded-lg">
                                    <div class="d-flex justify-content-between align-items-center pb-2 border-bottom">
                                        <div class="h3 mb-0">Trip info</div>
                                        <div>
                                            <a class="d-flex align-items-center text-decoration-none"
                                               @click="isEditingTrip = !isEditingTrip"
                                               v-if="!isEditingTrip && !booking.deleted_at && canEdit">
                                                <span
                                                    class="material-icons-outlined cursor-pointer text-primary">edit</span>
                                            </a>
                                            <a v-if="isEditingTrip" @click="isEditingTrip = false"
                                               class="text-decoration-none">
                                                <small>cancel editing</small>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="pt-3">
                                        <div class="container-fluid py-3 bg-white">
                                            <div class="row">
                                                <div class="col-md-3">
                                                    <label class="d-block mb-0 font-weight-bold">Products:</label>
                                                    <div>
                                                        <label class="newInput">
                                                            {{ booking.product ? booking.product.name : 'Product not found' }}
                                                            <input type="checkbox" checked disabled>
                                                            <span class="checkmark"></span>
                                                        </label>
                                                    </div>
                                                    <div v-if="booking.services_data.length>0 && !isEditingTrip">
                                                        <label class="d-block mb-0 font-weight-bold">Services:</label>
                                                        <div v-for="service in booking.services_data">
                                                            <div>
                                                                <label class="newInput">
                                                                    {{ service.name }}
                                                                    <input type="checkbox" checked disabled>
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="isEditingTrip">
                                                        <label class="d-block mb-0 font-weight-bold">Services:</label>

                                                        <div v-for="item in services"
                                                             v-if="item.service.deleted_at===null">
                                                            <label class="newInput">
                                                                {{ item.service.name }}
                                                                <input type="checkbox"
                                                                       name="serviceIds"
                                                                       :value="item.service.id"
                                                                       :checked="serviceIds.includes(item.service.id)"
                                                                       @change="onChangeServiceId($event)"
                                                                >
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </div>

                                                    </div>
                                                    <label class="d-block mb-0 font-weight-bold">Linehaul:</label>
                                                    <div v-if="!isEditingTrip">
                                                        <div>
                                                            <label class="newInput">
                                                                {{ booking.linehaul }}
                                                                <input type="checkbox" checked disabled>
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div v-else>
                                                        <select required
                                                                class="form-control"
                                                                v-model="booking.linehaul_type">
                                                            <option value="0-0">None</option>
                                                            <option value="1-2">EAST-WEST</option>
                                                            <option value="2-1">WEST-EAST</option>
                                                        </select>
                                                    </div>

                                                    <div class="form-group" v-if="role !== 'user'">
                                                        <label class="d-block mb-0 font-weight-bold">
                                                            Internal comment:
                                                        </label>
                                                        <div
                                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingTrip, 'border-danger': booking.internal_comment==='' && isSubmit}">
                                                           <textarea
                                                               rows="7"
                                                               class="form-control form-control border-1 py-0 shadow-none form-input"
                                                               :class="{view: !isEditingTrip}"
                                                               :disabled="!isEditingTrip"
                                                               v-model="booking.internal_comment"
                                                               placeholder="">
                                                           </textarea>
                                                        </div>
                                                    </div>

                                                </div>

                                                <div class="col-md-9">
                                                    <ul class="nav nav-tabs border d-inline-flex">
                                                        <li v-if="booking.pickup_trip">
                                                            <a data-toggle="tab" href="#pickup_tab"
                                                               class="btn btn-sm btn-white py-2 px-3"
                                                               :class="booking.status_id!==10 ? 'active' : ''">
                                                                Pick Up
                                                            </a>
                                                        </li>
                                                        <li v-if="booking.linehaul_trip"
                                                            class="border-left border-right">
                                                            <a data-toggle="tab" href="#linehaul_tab"
                                                               class="btn btn-sm btn-white py-2 px-3"
                                                               :class="booking.status_id===10 ? 'active' : ''">
                                                                LineHaul &nbsp;
                                                            </a>
                                                        </li>
                                                        <li v-if="booking.dropoff_trip">
                                                            <a data-toggle="tab" href="#dropoff_tab"
                                                               class="btn btn-sm btn-white py-2 px-3"
                                                               :class="(booking.status_id===10 && !booking.linehaul_trip) ||  (!booking.pickup_trip  && !booking.linehaul_trip)  ? 'active' : ''">
                                                                Drop-off
                                                            </a>
                                                        </li>
                                                    </ul>

                                                    <div class="tab-content pt-3">
                                                        <div id="pickup_tab"
                                                             class="tab-pane fade"
                                                             :class="booking.status_id!==10 ? 'active show' : ''"
                                                             v-if="booking.pickup_trip">
                                                            <div class="timeline">
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.pickup_trip.status>=0 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label class="mb-0 font-weight-semi-bold">Awaiting
                                                                            date</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.pickup_trip.status>=1 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">New</label>
                                                                    </div>
                                                                </div>
                                                                <div v-if="tripCanBeMarkedAsForeign(booking.pickup_trip, booking.pickup_address)"
                                                                    class="container-time  time-right"
                                                                    :class="booking.pickup_trip.status==11 || booking.pickup_trip.status>=1 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Foreign</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.pickup_trip.status>=2 && booking.pickup_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Transferred</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.pickup_trip.status>=3 && booking.pickup_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Scheduled</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.pickup_trip.status>=4 && booking.pickup_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Servicing</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.pickup_trip.status>=5 && booking.pickup_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Failed</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.pickup_trip.status>=6 && booking.pickup_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Rejected</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.pickup_trip.status>=7 && booking.pickup_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Delivered</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="">
                                                                <div style="display:inline-block;" class="ml-3">
                                                                    <a v-if="role !== 'user'"
                                                                       :href="`/trips/${booking.pickup_trip.id}/edit`"
                                                                       class="btn btn-primary">View trip</a>
                                                                </div>
                                                                <div style="display:inline-block;"
                                                                     class="btn btn-success ml-3"
                                                                     @click="setTripDelivered(booking.pickup_trip.id, 1)">
                                                                    <i title="mark delivered"></i> Mark delivered
                                                                </div>
                                                                <div style="display:inline-block;"
                                                                     v-if="booking.pickup_trip.status === 5"
                                                                     class="btn btn-danger ml-3 mr-3"
                                                                     @click="setTripRejected(booking.pickup_trip.id, deliveredDate.pickupDate)">

                                                                    <i title="mark rejected"></i> Mark rejected
                                                                </div>
                                                                <div v-if="false && booking.pickup_trip.tw_start===null"
                                                                     class="trip-actions">
                                                                    <!-- hidden as https://app.asana.com/1/938290244899/task/1210064868430051/comment/1210094793044279?focus=true -->
                                                                    <div
                                                                        class="bg-white border- rounded-lg div-focus border-2">
                                                                        <date-picker
                                                                            manual-input
                                                                            v-model="deliveredDate.pickupDate"
                                                                            valueType="format"
                                                                            input-class="border-0 py-0 shadow-none form-input"
                                                                            placeholder="DD-MM-YYYY"
                                                                            :lang="datePickerOptions.lang"
                                                                            format="DD-MM-YYYY">
                                                                        </date-picker>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div id="linehaul_tab"
                                                             class="tab-pane fade"
                                                             :class="booking.status_id===10 ? 'active show' : ''"
                                                             v-if="booking.linehaul_trip">
                                                            <div class="timeline">
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.linehaul_trip.status>=1 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">New</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.linehaul_trip.status>=2 && booking.linehaul_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Transferred</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.linehaul_trip.status>=3 && booking.linehaul_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Scheduled</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.linehaul_trip.status>=4 && booking.linehaul_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Servicing</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.linehaul_trip.status>=5 && booking.linehaul_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Failed</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.linehaul_trip.status>=6 && booking.linehaul_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Rejected</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.linehaul_trip.status>=7 && booking.linehaul_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Delivered</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <a v-if="role !== 'user'"
                                                               :href="`/trips/${booking.linehaul_trip.id}/edit`"
                                                               class="btn btn-primary ml-3">View trip</a>

                                                            <div class="btn btn-success ml-3"
                                                                 @click="setTripDelivered(booking.linehaul_trip.id, 2)">
                                                                <i title="mark delivered"></i>Mark delivered
                                                            </div>
                                                            <div v-if="booking.linehaul_trip.status === 5"
                                                                 class="btn btn-danger ml-3"
                                                                 @click="setTripRejected(booking.linehaul_trip.id)">
                                                                <i title="mark rejected"></i> Mark rejected
                                                            </div>

                                                        </div>
                                                        <div id="dropoff_tab"
                                                             class="tab-pane fade"
                                                             :class="(booking.status_id===10 && !booking.linehaul_trip) ||  (!booking.pickup_trip  && !booking.linehaul_trip)  ? 'active show' : ''"
                                                             v-if="booking.dropoff_trip">
                                                            <div class="timeline">
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.dropoff_trip.status>=0 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label class="mb-0 font-weight-semi-bold">Awaiting
                                                                            date</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.dropoff_trip.status>=1 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">New</label>
                                                                    </div>
                                                                </div>
                                                                <div v-if="tripCanBeMarkedAsForeign(booking.dropoff_trip, booking.dropoff_address)"
                                                                     class="container-time  time-right"
                                                                     :class="booking.dropoff_trip.status==11 || booking.dropoff_trip.status>=1 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Foreign</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.dropoff_trip.status>=2 && booking.dropoff_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Transferred</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.dropoff_trip.status>=3 && booking.dropoff_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Scheduled</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.dropoff_trip.status>=4 && booking.dropoff_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Servicing</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.dropoff_trip.status>=5 && booking.dropoff_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Failed</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.dropoff_trip.status>=6 && booking.dropoff_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Rejected</label>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="container-time  time-right"
                                                                    :class="booking.dropoff_trip.status>=7 && booking.dropoff_trip.status!=11 ? 'isChecked' : ''">
                                                                    <div class="content-timer bg-light">
                                                                        <label
                                                                            class="mb-0 font-weight-semi-bold">Delivered</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <a v-if="role !== 'user'"
                                                               :href="`/trips/${booking.dropoff_trip.id}/edit`"
                                                               class="btn btn-primary ml-3">View trip
                                                            </a>
                                                            <div class="btn btn-success ml-3"
                                                                 @click="setTripDelivered(booking.dropoff_trip.id, 3)">
                                                                <i title="mark delivered"></i> Mark delivered
                                                            </div>
                                                            <div v-if="booking.dropoff_trip.status === 5"
                                                                 class="btn btn-danger ml-3 mr-3"
                                                                 @click="setTripRejected(booking.dropoff_trip.id)">
                                                                <i title="mark rejected"></i> Mark rejected
                                                            </div>
                                                            <div v-if="booking.dropoff_trip.tw_start===null"
                                                                 class="trip-actions">
                                                                <div
                                                                    class="bg-white border- rounded-lg div-focus border-2">
                                                                    <date-picker
                                                                        manual-input
                                                                        v-model="deliveredDate.dropoffDate"
                                                                        valueType="format"
                                                                        input-class="border-0 py-0 shadow-none form-input"
                                                                        placeholder="date"
                                                                        :lang="datePickerOptions.lang"
                                                                        format="DD-MM-YYYY">
                                                                    </date-picker>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="card mb-4 box-shadow h-100">
                            <div class="card-body">
                                <div class="p-4 mb-0 bg-white rounded-lg"
                                     :class="booking.status_id===1 && (booking.product_price==='' || booking.product_price===0)?'border border-danger border-width-3':''"
                                >
                                    <div class="pb-3" v-if="role !== roleUser">
                                        <label class="newInput">
                                            <strong>Exclude booking from Drivers cost report</strong>
                                            <input type="checkbox"
                                                   v-model="excludeFromDriverCostReport"
                                                   @change="onChangeExcludeFromDriverCostReport"
                                            >
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <div class="d-flex justify-content-between align-items-center pb-2 border-bottom ">
                                        <div class="h3 mb-0">Price</div>
                                        <span class="edit-product"></span>
                                        <div>
                                    <span
                                        @click="scrollToElement({behavior: 'smooth'},'edit-product');isEditingProduct = !isEditingProduct;"
                                        v-if="!isEditingProduct  && !booking.deleted_at && canEdit"
                                        class="text-decoration-none">
                                        <span class="material-icons-outlined cursor-pointer text-primary">edit</span>
                                    </span>
                                            <a href="#" v-if="isEditingProduct" @click="isEditingProduct = false"
                                               class="text-decoration-none">
                                                <small>cancel editing</small>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="pt-3">
                                        <div class="table-responsive">
                                            <table class="table border" aria-label="table-price">
                                                <thead>
                                                <tr>
                                                    <th scope="col">Product</th>
                                                    <th scope="col" class="text-center">Price</th>
                                                    <th scope="col" class="text-center">Amount</th>
                                                    <th scope="col" class="text-center">Unit</th>
                                                    <th scope="col" class="text-center">Total Price</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td class="text-center"> {{ booking.product ? booking.product.name : 'Product not found' }}</td>
                                                    <td class="text-center">
                                                        <div v-if="booking.product && booking.product.price_type===1">
                                                            <div
                                                                :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingProduct, 'border-danger': booking.product_price==='' && isSubmit}">
                                                                <input type="text"
                                                                       autocomplete="off"
                                                                       required
                                                                       class="form-control text-center border-0 py-0 shadow-none form-input"
                                                                       placeholder="price"
                                                                       v-model="booking.product_price"
                                                                       :disabled="!isEditingProduct || role === 'user'"
                                                                       :class="{view: !isEditingProduct}">
                                                                <div class="help-block with-errors"></div>
                                                            </div>
                                                        </div>
                                                        <div v-else>
                                                            <div
                                                                :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingProduct, 'border-danger': booking.product_price==='' && isSubmit}">
                                                                <input type="text"
                                                                       autocomplete="off"
                                                                       required
                                                                       class="form-control text-center border-0 py-0 shadow-none form-input"
                                                                       placeholder="price"
                                                                       v-model="booking.product_price"
                                                                       :disabled="!isEditingProduct || role === 'user'"
                                                                       :class="{view: !isEditingProduct}">
                                                                <div class="help-block with-errors"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td class="text-center">

                                                        <div
                                                            v-if="isEditingProduct && booking.product && booking.product.price_type!==1">
                                                            <input type="number" min="0" step="0.1"
                                                                   autocomplete="off"
                                                                   class="form-control text-center border-0 py-0 shadow-none form-input"
                                                                   placeholder="time units"
                                                                   :disabled="role === 'user'"
                                                                   @change="recalculateTimeUnitsProduct($event, booking.id, booking.product_time_units)"
                                                                   :value="booking.product_time_units">
                                                        </div>
                                                        <div v-else>
                                                            {{
                                                                (booking.product && booking.product.price_type === 1) ? 1 :
                                                            booking.product_time_units
                                                            }}
                                                        </div>
                                                    </td>
                                                    <td class="text-center">
                                                        <div v-if="booking.product && booking.product.price_type===1">
                                                            pcs
                                                        </div>
                                                        <div v-else-if="booking.product && booking.product.price_type===2">
                                                            hours
                                                        </div>
                                                        <div v-else-if="booking.product && booking.product.price_type===3">
                                                            days
                                                        </div>
                                                        <div v-else-if="booking.product && booking.product.price_type===4">
                                                            weeks
                                                        </div>
                                                        <div v-else-if="booking.product && booking.product.price_type===5">
                                                            months
                                                        </div>
                                                        <div v-else>
                                                            years
                                                        </div>
                                                    </td>
                                                    <td class="text-center">
                                                        {{ booking.product_price }}
                                                        <!--                                                        <div
                                                                                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingProduct, 'border-danger': booking.product_price==='' && isSubmit}">
                                                                                                                    <input type="text"
                                                                                                                           autocomplete="off"
                                                                                                                           required
                                                                                                                           class="form-control text-center border-0 py-0 shadow-none form-input"
                                                                                                                           placeholder="price"
                                                                                                                           v-model="booking.product_price"
                                                                                                                           :disabled="!isEditingProduct"
                                                                                                                           :class="{view: !isEditingProduct}">
                                                                                                                    <div class="help-block with-errors"></div>
                                                                                                                </div>-->
                                                    </td>
                                                </tr>

                                                <tr v-if="booking.services_data.length>0">
                                                    <th scope="col">Service</th>
                                                    <th scope="col" class="text-center">Price</th>
                                                    <th scope="col" class="text-center">Amount</th>
                                                    <th scope="col" class="text-center">Unit</th>
                                                    <th scope="col" class="text-center">Total Price</th>
                                                </tr>

                                                <tr v-for="service in booking.services_data">
                                                    <td class="text-center"> {{ service.name }}</td>
                                                    <td class="text-center">
                                                        <div
                                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingProduct, 'border-danger': service.price==='' && isSubmit}">
                                                            <input type="text"
                                                                   autocomplete="off"
                                                                   required
                                                                   class="form-control text-center border-0 py-0 shadow-none form-input"
                                                                   placeholder="price"
                                                                   v-model="service.price"
                                                                   :disabled="!isEditingProduct || role === 'user'"
                                                                   :class="{view: !isEditingProduct}">
                                                            <div class="help-block with-errors"></div>
                                                        </div>
                                                    </td>

                                                    <td class="text-center">
                                                        <div
                                                            v-if="isEditingProduct && service.price_type!==1">
                                                            <input type="number" min="0" step="0.1"
                                                                   autocomplete="off"
                                                                   class="form-control text-center border-0 py-0 shadow-none form-input"
                                                                   placeholder="time units"
                                                                   @change="recalculateTimeUnitsService($event, service.id, service.time_unit)"
                                                                   :disabled="role === 'user'"
                                                                   :value="service.time_unit"
                                                            >
                                                        </div>
                                                        <div v-else>
                                                            <div v-if="service.price_type === 1">
                                                                1
                                                            </div>
                                                            <div v-else>
                                                                {{ service.time_unit }}
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td class="text-center">
                                                        <div v-if="service.price_type===1">
                                                            pcs
                                                        </div>
                                                        <div v-else-if="service.price_type===2">
                                                            hours
                                                        </div>
                                                        <div v-else-if="service.price_type===3">
                                                            days
                                                        </div>
                                                        <div v-else-if="service.price_type===4">
                                                            weeks
                                                        </div>
                                                        <div v-else-if="service.price_type===5">
                                                            months
                                                        </div>
                                                        <div v-else>
                                                            years
                                                        </div>
                                                    </td>
                                                    <td class="text-center">
                                                        {{ service.price }}
                                                    </td>
                                                </tr>
                                                <tr v-if="booking.agreement_insurances_id && !insuranceInCustomerOptions">
                                                    <th>Insurance</th>
                                                    <th scope="col" class="text-center">Price</th>
                                                    <th scope="col" class="text-center">Amount</th>
                                                    <th scope="col" class="text-center">Unit</th>
                                                    <th scope="col" class="text-center">Total Price</th>
                                                </tr>
                                                <tr v-if="booking.agreement_insurances_id && !insuranceInCustomerOptions">
                                                    <td class="text-center">
                                                        {{ booking.agreementInsurance.insurance ? booking.agreementInsurance.insurance.name : '' }}
                                                    </td>
                                                    <td class="text-center">
                                                        <div v-if="!isEditingProduct">{{  booking.insurances_price }}</div>
                                                        <div
                                                            v-else
                                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                            :class="{'border-danger': booking.insurances_price === '' && isSubmit}">
                                                            <input type="number"
                                                                   min="0"
                                                                   step="0.01"
                                                                   autocomplete="off"
                                                                   required
                                                                   class="form-control text-center border-0 py-0 shadow-none form-input"
                                                                   placeholder="price"
                                                                   v-model="booking.insurances_price"
                                                                   :disabled="!isEditingProduct || role === 'user'"
                                                                   :class="{view: !isEditingProduct}">
                                                        </div>
                                                    </td>
                                                    <td class="text-center">1</td>
                                                    <td class="text-center">pcs</td>
                                                    <td class="text-center">{{ booking.insurances_price }}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="3"></td>
                                                    <th scope="row" class="white-space-nowrap text-right"> Total excl. VAT</th>
                                                    <td class="white-space-nowrap text-center">
                                                        {{ calcTotalExclVat() }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colspan="3"></td>
                                                    <th scope="row" class="white-space-nowrap text-right"> VAT</th>
                                                    <td class="white-space-nowrap text-center">
                                                        {{ calcTotalExclVat() * vat }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colspan="3"></td>
                                                    <th scope="row" class="white-space-nowrap text-right">Total incl. VAT</th>
                                                    <td class="white-space-nowrap text-center">
                                                        {{ calcTotalExclVat() * (1 + vat) }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colspan="5"></td>
                                                </tr>
                                                <tr v-if="role !== roleUser">
                                                    <td class="text-center"> Cost price</td>
                                                    <td class="text-center">
                                                        <div
                                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingProduct, 'border-danger': booking.cost_price==='' && isSubmit}">
                                                            <input type="text"
                                                                   autocomplete="off"
                                                                   required
                                                                   class="form-control text-center border-0 py-0 shadow-none form-input"
                                                                   placeholder="price"
                                                                   v-model="booking.cost_price"
                                                                   :disabled="!isEditingProduct"
                                                                   :class="{view: !isEditingProduct}">
                                                        </div>
                                                    </td>
                                                    <td class="text-center"></td>
                                                    <td class="text-center"></td>
                                                    <td class="text-center"></td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <div class="p-4 mb-0 bg-white rounded-lg">
                                    <div class="d-flex justify-content-between align-items-center pb-2 border-bottom ">
                                        <div class="h3 mb-0">Upgrade</div>
                                    </div>
                                    <div class="pt-3" v-for="customerOptions in booking.customerOptions">
                                        <div class="table-responsive">
                                            <table class="table border" aria-label="table-upgrade">
                                                <thead>
                                                <tr>
                                                    <th scope="col" style="width: 43%;">Option</th>
                                                    <th scope="col" style="width: 42%;" class="text-center">Value</th>
                                                    <th scope="col" style="width: 15%;" class="text-center">Price</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="(service, key) in customerOptions.options" v-if="service.enabled && (service.value || service.price)">
                                                    <td>{{ service.name }}</td>
                                                    <td class="text-center">
                                                        <span v-if="!key.includes('ShorterTimeInterval') && service.name !== 'Adresseændring'">{{ service.value }}</span>
                                                        <span v-else-if="service.name === 'Adresseændring'">
                                                            Name - {{ service.value.name }},
                                                            Street - {{ service.value.street }},
                                                            City - {{ service.value.city }},
                                                            Zip - {{ service.value.zip }},
                                                            Phone - {{ service.value.phone }}
                                                        </span>
                                                        <span v-else>{{ service.value.when }} {{ service.value.time }}</span>
                                                    </td>
                                                    <td class="text-center">{{ service.price }}</td>
                                                </tr>
                                                <tr v-for="(service) in customerOptions.options[primeKey]" v-if="typeof(service) === 'object' && service.enabled">
                                                    <td>{{ service.name }}:</td>
                                                    <td class="text-center"></td>
                                                    <td class="text-center">{{ service.price }}</td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <th scope="row" class="white-space-nowrap text-right"> Total excl. VAT</th>
                                                    <td class="white-space-nowrap text-center">
                                                        {{ calcTotalExclVatForUpgrade(customerOptions.options) }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <th scope="row" class="white-space-nowrap text-right"> VAT</th>
                                                    <td class="white-space-nowrap text-center">
                                                        {{ calcTotalExclVatForUpgrade(customerOptions.options) * vat }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <th scope="row" class="white-space-nowrap text-right">Total incl. VAT</th>
                                                    <td class="white-space-nowrap text-center">
                                                        {{ calcTotalExclVatForUpgrade(customerOptions.options) * (1 + vat) }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colspan="3">
                                                        <div class="d-flex align-items-center justify-content-between"
                                                             v-if="customerOptions.transaction">
                                                            <strong>Payment details:</strong>
                                                            <div>
                                                                <strong>Status:</strong>
                                                                <span>
                                                                    {{ paymentStatuses[customerOptions.transaction.status] }}
                                                                </span>
                                                            </div>
                                                            <div>
                                                                <strong>Invoice:</strong>
                                                                <span>
                                                                    {{ customerOptions.transaction.invoice_guid }}
                                                                </span>
                                                            </div>
                                                            <div>
                                                                <strong>Date:</strong>
                                                                <span>
                                                                    {{
                                                                        customerOptions.transaction ?
                                                                        formatDateTime(customerOptions.transaction.updated_at) :
                                                                        ''
                                                                    }}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="container-fluid bg-light py-3">
                <div class="row">
                    <div class="col-md-6">
                        <div class="card mb-4 box-shadow h-100">
                            <div class="card-body">
                                <!-- If null booking.logs value comes from controller section will be hidden -->
                                <div
                                    v-if="booking.logs !== null"
                                    class="p-4 mb-0 bg-white rounded-lg">
                                    <div class="d-flex justify-content-between align-items-center pb-2 border-bottom ">
                                        <div class="h3 mb-0">Logging</div>
                                    </div>
                                    <div class="pt-3">
                                        <div class="table-responsive">
                                            <table class="table table-striped border" aria-label="Logs table">
                                                <thead>
                                                <tr>
                                                    <th>Activity</th>
                                                    <th>Initiated by</th>
                                                    <th>Time</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-if="booking.logs" v-for="log in booking.logs">
                                                    <td>
                                                        <span v-if="log.action === logActionUpdated ||
                                                         log.action === logActionCustomerChangedOptions"
                                                        >
                                                            <a @click.prevent="toggleModalLog(log.id)"
                                                                href="#">{{ log.action }}</a>
                                                        </span>
                                                        <span v-else>
                                                             {{ log.action }}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        {{
                                                        log.initiated_by !== null ? log.initiated_by : log.user.email
                                                        }}
                                                    </td>
                                                    <td>{{ formatDateTime(log.action_time) }}</td>
                                                </tr>
                                                <tr v-if="!booking.logs">
                                                    <td>Booking created</td>
                                                    <td>Admin</td>
                                                    <td>{{ booking.created_at }}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <div class="p-4 mb-0 bg-white rounded-lg">
                                    <div class="d-flex justify-content-between align-items-center pb-2 border-bottom ">
                                        <div class="h3 mb-0">SMS Logging</div>
                                    </div>
                                    <div class="pt-3">
                                        <div class="table-responsive">
                                            <table class="table table-striped border" aria-label="Sms logs table">
                                                <thead>
                                                <tr>
                                                    <th>Sms type</th>
                                                    <th>Status</th>
                                                    <th>Sent at</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-if="booking.smsLogs"
                                                    v-for="log in booking.smsLogs"
                                                    @click="toggleModalSmsLog(log.id)"
                                                >
                                                    <td>{{ log.title }}</td>
                                                    <td>
                                                        <span>{{ log.status }}</span>
                                                        <span v-if="log.details && log.details.errorCode">
                                                            &nbsp({{ log.details.errorCode }})
                                                        </span>
                                                    </td>
                                                    <td>{{ formatDateTime(log.sent_at) }}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div v-if="role !== 'user'" class="col-md-6">
                        <div class="card mb-4 box-shadow h-100">
                            <div class="card-body">
                                <div v-if="role !== 'user'" class="p-4 mb-0 bg-white rounded-lg">
                                    <div class="d-flex justify-content-between align-items-center pb-2 border-bottom">
                                        <div class="h3 mb-0">Communication</div>
                                    </div>

                                    <div class="pt-3">
                                        <div class="table-responsive">
                                            <table class="table table-striped border">
                                                <thead>
                                                <tr>
                                                    <th>Type</th>
                                                    <th>Initiated by</th>
                                                    <th>Time</th>
                                                    <th>Status</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="value in communicationLog">
                                                    <td>{{ value.communication_type == 1 ? 'SMS' : 'EMAIL' }}</td>
                                                    <td>Admin</td>
                                                    <td>
                                                        {{
                                                        new Date(value.created_at).toLocaleString('da-DK', {
                                                        year: "numeric",
                                                        month: "2-digit",
                                                        day: "2-digit",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        })
                                                        }}
                                                    </td>
                                                    <td>{{ value.statuss === 'success' ? 'success' : 'not sent' }}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="container-fluid bg-light py-3">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card mb-4 box-shadow h-100">
                                    <div class="card-body">
                                        <div class="p-4 mb-0 bg-white rounded-lg">
                                            <div
                                                class="d-flex justify-content-between align-items-center pb-2 border-bottom ">
                                                <div class="h3 mb-0">Products</div>
                                            </div>
                                            <div class="pt-3">
                                                <div class="table-responsive">
                                                    <table class="table border">
                                                        <tbody>
                                                        <tr>
                                                            <th>Reference</th>
                                                            <th>Name</th>
                                                            <th>Colli</th>
                                                            <th>Volume(m3)</th>
                                                            <th>Weight(kg)</th>
                                                            <th>Location</th>
                                                            <th>
                                                                <a v-if="isEditingColli"
                                                                   @click="isEditingColli = false; booking.colliDataChanged=!booking.colliDataChanged"
                                                                   class="text-decoration-none">
                                                                    <small>cancel editing</small>
                                                                </a>
                                                            </th>
                                                            <th></th>
                                                        </tr>
                                                        <tr v-for="(colli,k) in booking.colli_data">
                                                            <td>
                                                                <div class="form-group">
                                                                    <div
                                                                        :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingColli, 'border-danger': booking.volume==='' && isSubmit}">
                                                                        <input type="text"
                                                                               autocomplete="off"
                                                                               required
                                                                               class="form-control  border-0 py-0 shadow-none form-input"
                                                                               placeholder="reference"
                                                                               v-model="colli.reference"
                                                                               :disabled="!isEditingColli"
                                                                               :class="{view: !isEditingColli}">
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>

                                                                <div class="form-group">
                                                                    <div
                                                                        :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingColli, 'border-danger': booking.volume==='' && isSubmit}">
                                                                        <input type="text"
                                                                               autocomplete="off"
                                                                               class="form-control  border-0 py-0 shadow-none form-input"
                                                                               v-model="colli.name"
                                                                               :disabled="!isEditingColli"
                                                                               :class="{view: !isEditingColli}">
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="form-group">
                                                                    <div
                                                                        :class="{'d-flex align-items-center div-focus':isEditingColli, 'border-danger': booking.volume==='' && isSubmit}">
                                                                        <div
                                                                            @click="removeSingleColliFromBatch(colli.colli_batch)"
                                                                            class="material-icons-outlined cursor-pointer text-primary"
                                                                            title="remove colli">remove
                                                                        </div>
                                                                        <span class="colli-number"> {{
                                                                                colli.totalColliAmountByColliBatch ||
                                                                                colli.colli
                                                                            }}
                                                                        </span>
                                                                        <div
                                                                            @click="addSingleColliToBatch(colli.colli_batch)"
                                                                            class="material-icons-outlined cursor-pointer text-primary"
                                                                            title="add colli">add
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="form-group">
                                                                    <div
                                                                        :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingColli, 'border-danger': booking.volume==='' && isSubmit}">
                                                                        <input type="text"
                                                                               autocomplete="off"
                                                                               required
                                                                               class="form-control  border-0 py-0 shadow-none form-input"
                                                                               v-model="colli.totalVolume"
                                                                               :disabled="!isEditingColli"
                                                                               :class="{view: !isEditingColli}"
                                                                               @change="recalculateCollis"
                                                                        >
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="form-group">
                                                                    <div
                                                                        :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingColli, 'border-danger': booking.volume==='' && isSubmit}">
                                                                        <input type="text"
                                                                               autocomplete="off"
                                                                               required
                                                                               class="form-control  border-0 py-0 shadow-none form-input"
                                                                               v-model="colli.totalWeight"
                                                                               :disabled="!isEditingColli"
                                                                               :class="{view: !isEditingColli}"
                                                                               @change="recalculateCollis"
                                                                        >
                                                                    </div>
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <div v-if="colli.location!==null">
                                                                    <div
                                                                        v-for="(location,key) in colli.grouppedByLocations">

                                                                        {{ key.split('(')[0] }}
                                                                        ({{ location }})
                                                                        ({{ key.split('(')[1] }} <br/>
                                                                    </div>
                                                                </div>
                                                            </td>

                                                            <td v-if="canEdit || booking.status_id===1">
                                                                <div>
                                                                    <a @click="isEditingColli = !isEditingColli;booking.colliDataChanged=!booking.colliDataChanged"
                                                                       class="text-decoration-none"
                                                                       v-if="!isEditingColli  && !booking.deleted_at">
                                                                        <div
                                                                            class="material-icons-outlined cursor-pointer text-primary">
                                                                            edit
                                                                        </div>
                                                                    </a>
                                                                </div>
                                                            </td>
                                                            <td v-if="canEdit || booking.status_id===1">
                                                                <div title="delete colli"
                                                                     @click="deleteColli(k, colli.isExisting, colli.id)"
                                                                     class="material-icons-outlined cursor-pointer
                                                                     text-primary" bis_skin_checked="1">
                                                                    delete
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="canEdit || booking.status_id===1">
                                                            <td>
                                                                <div class="form-group">
                                                                    <input type="text"
                                                                           autocomplete="off"
                                                                           class="form-control"
                                                                           placeholder="123456 (order #)"
                                                                           v-model="colli.reference">
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="form-group">
                                                                    <input type="text"
                                                                           autocomplete="off"
                                                                           class="form-control"
                                                                           placeholder="Blue chair"
                                                                           v-model="colli.name">
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <div class="form-group">
                                                                    <input type="text"
                                                                           autocomplete="off"
                                                                           class="form-control"
                                                                           v-model="colli.colli">
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <div class="form-group">
                                                                    <input type="text"
                                                                           autocomplete="off"
                                                                           class="form-control"
                                                                           v-model="colli.volume"
                                                                    >
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="form-group">
                                                                    <input type="text"
                                                                           autocomplete="off"
                                                                           class="form-control"
                                                                           v-model="colli.weight"
                                                                    >
                                                                </div>
                                                            </td>
                                                            <td></td>
                                                            <td>
                                                                <div class="form-group">
                                                                    <div class="btn btn-success sm" @click="addColli()">
                                                                        <div
                                                                            class="material-icons-outlined cursor-pointer mr-1">
                                                                            add_circle
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>

                                                            </td>
                                                        </tr>
                                                        <tr v-if="showClientColliList">
                                                            <td colspan="11">
                                                                <div>
                                                                    <b>Products already in the Step Transport warehouse:
                                                                    </b>
                                                                </div>
                                                                <div class="col-md-3 search-colli">
                                                                    <div class="form-group">
                                                                        <input type="text" autocomplete="off"
                                                                               @input="findColliByReference($event)"
                                                                               class="form-control"
                                                                               placeholder="Search for colli reference...">
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr v-for="colli in clientColliList">
                                                            <td>
                                                                <div class="form-group">
                                                                    {{ colli.reference }}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="form-group">
                                                                    {{ colli.name }}
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <div class="form-group">
                                                                    {{ colli.totalColliAmountByColliBatch }}
                                                                </div>
                                                            </td>

                                                            <td>
                                                                {{ colli.volume }}
                                                            </td>
                                                            <td>
                                                                {{ colli.weight }}
                                                            </td>
                                                            <td>
                                                                <div v-if="colli.location!==null">
                                                                    {{ colli.location.name }}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="form-group">
                                                                    <div class="btn btn-success sm"
                                                                         @click="addExistingColli(colli.id)">
                                                                        <div
                                                                            class="material-icons-outlined cursor-pointer mr-1">
                                                                            add_circle
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>

                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                    <div
                                                        v-if="!showClientColliList && (canEdit || booking.status_id===1)"
                                                        class="btn add-warehouse btn-success"
                                                        @click="getClientColliList">
                                                        Add from Step Warehouse
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 action-block save-button" v-if="!booking.deleted_at">
                        <button v-if="canEdit" type="submit" class="btn btn-primary float-left"
                                @click="validation()">
                            Save
                        </button>
                        <div v-if="booking.status_id===1 && role !== 'user'" @click="confirmBooking()"
                             class="btn btn-success d-flex align-items-center float-left button-success-text confirm-button"
                             title="Confirm booking">
                            <span class="">Confirm booking</span>
                        </div>

                        <div v-if="canDelete"
                             @click="deleteBooking()"
                             class="btn btn-primary d-flex align-items-center float-left delete-button"
                             title="Delete booking">
                            <div class="material-icons-outlined cursor-pointer mr-1"
                                 title="delete">delete
                            </div>
                            <div>Delete Booking</div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <br/>
        <br/>
        <a :href="backUrl" title="Back" class="text-decoration-none" @click.prevent="goBack">
            <button class="btn default btn-sm d-flex align-items-center">
                <span class="material-icons-outlined cursor-pointer text-primary">arrow_back</span>
                <span class="pl-1">Back</span>
            </button>
        </a>

        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalInterval}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Do you want to change the date of the drop-off trip?</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModal"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="addDropoffDate">
                            <div class="form-group">
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                    <date-picker
                                        required
                                        manual-input
                                        v-model="dropoffDate.date" valueType="format"
                                        input-class="border-0 py-0 shadow-none form-input"
                                        :lang="datePickerOptions.lang"
                                        placeholder="dd-mm-yyyy" format="DD-MM-YYYY">
                                    </date-picker>
                                </div>
                            </div>

                            <button class="btn btn-success">
                                Confirm
                            </button>
                            <div class="btn btn-primary mark-delivered" @click="toggleModal">
                                Cancel
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalInterval" class="modal-backdrop fade show"></div>

        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalIntervalLog}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Changed data</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModalLog(logData.id)"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="logData.description">
                            <div v-if="logData.action === logActionCustomerChangedOptions">
                                <div v-for="(service,key) in JSON.parse(logData.description)">
                                    <div v-if="service.name && (service.value || service.price)">
                                        <span>{{ service.name }}:</span>
                                        <span v-if="[newDeliveryDateKey, newPickupDateKey].includes(key)">
                                            {{ service.value.replace(/\(.*/, '') }}
                                        </span>
                                        <span v-else-if="!key.includes('ShorterTimeInterval')">{{ service.value }}</span>
                                        <span v-else>{{ service.value.when }} {{ service.value.time }}</span>
                                        <span>(+{{ calculatePriceWithVatAndRoundToNearestTens(service.price) }} kr.)</span>
                                    </div>
                                    <div v-else-if="service.key === primeKey">
                                        <div v-for="primeService in service" v-if="typeof primeService === 'object'">
                                            <span>{{ primeService.name }}:</span>
                                            <span>({{ calculatePriceWithVatAndRoundToNearestTens(primeService.price) }} kr.)</span>
                                        </div>
                                    </div>
                                </div>
                                <br>
                                <div>Total price</div>
                                <div> {{ calcTotalForLog(JSON.parse(logData.description)) }} kr.</div>
                            </div>
                            <div v-else>
                                <div v-for="(detail,k) in JSON.parse(logData.description)">
                                    <b>{{ k }}:</b>
                                    {{ detail[0] }} -> {{ detail[1] }}
                                    <br/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalIntervalLog" class="modal-backdrop fade show"></div>

        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalIntervalSmsLog}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Sms log. Log id: {{ smsLogData.id }}</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModalSmsLog(smsLogData.id)"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div><strong>Type:</strong> {{ smsLogData.title }}</div>
                        <div><strong>Recipient:</strong> {{ smsLogData.phone }}</div>
                        <div><strong>Status:</strong> {{ smsLogData.status }}</div>
                        <div><strong>Sent at:</strong> {{ smsLogData.sent_at }}</div>
                        <div v-if="smsLogData.details && smsLogData.details.errorCode">
                            <strong>Error code:</strong>
                            <a :href="'https://www.twilio.com/docs/api/errors/' + smsLogData.details.errorCode"
                               target="_blank">
                                {{ smsLogData.details.errorCode }}
                            </a>
                        </div>
                        <div v-if="smsLogData.details && smsLogData.details.errorMessage">
                            <strong>Error message:</strong> {{ smsLogData.details.errorMessage }}
                        </div>
                        <div v-if="smsLogData.details && smsLogData.details.text">
                            <strong>Sms text:</strong>
                            <div>{{ smsLogData.details.text }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalIntervalSmsLog" class="modal-backdrop fade show"></div>

        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalIntervalType}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Change type
                            <span v-if="booking.booking_type===1"> Internal → External </span>
                            <span v-else> External → Internal </span>
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModalType"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <div v-if="booking.booking_type===1">
                            <div class="form-group">
                                <div class="align-items-center bg-white rounded-lg div-focus">
                                    <v-select
                                        :options="driverList"
                                        v-model="booking.driver"
                                        :clearSearchOnSelect="false"
                                        label="name"
                                    >
                                    </v-select>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="align-items-center bg-white rounded-lg div-focus">
                                    <input type="text"
                                           autocomplete="off"
                                           required
                                           class="form-control py-0 shadow-none form-input"
                                           placeholder="cost price"
                                           v-model="booking.cost_price"
                                    >
                                </div>
                            </div>
                        </div>

                        <button class="btn btn-success" @click="changeBookingType">
                            Confirm
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalIntervalType" class="modal-backdrop fade show"></div>

        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalMessage}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Important!</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModalMessage"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div>{{ warningMessage }} </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-success" @click="toggleModalMessage">
                            Ok
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalMessage" class="modal-backdrop fade show"></div>

        <div
            ref="modalForceSms"
            class="modal fade"
            :class="{show, 'd-block': activeModalForceSms}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Important!</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModalForceSms"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div>Er du sikker på at du vil sende {{ selectedSmsTemplate.title }} til denne kunde igen?</div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-success" @click="smsSend(selectedSmsTemplate, true)">
                            Ja
                        </button>
                        <button class="btn btn-primary" @click="toggleModalForceSms">
                            Nej
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalForceSms" class="modal-backdrop fade show"></div>

        <div
            ref="modalCopyBooking"
            class="modal fade"
            :class="{show, 'd-block': activeModalCopyBooking}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Copy booking</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModalCopyBooking"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3 d-flex justify-content-between">
                            <div>
                                <div>
                                    <label for="booking-copy-dropoff-date">
                                        <strong>Pickup date</strong>
                                    </label>
                                </div>
                                <div style="display:inline-block; width:200px;">
                                    <div
                                        class="rounded-lg div-focus border border-2">
                                        <date-picker
                                            manual-input
                                            v-model="bookingCopy.pickupDate"
                                            valueType="format"
                                            input-class="border-0 py-0 ml-0 shadow-none form-input"
                                            placeholder="date"
                                            :lang="datePickerOptions.lang"
                                            format="DD-MM-YYYY"
                                            id="booking-copy-dropoff-date"
                                            :clearable="false"
                                            :disabled-date="disabledDates"
                                        >
                                        </date-picker>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <label class="newInput">
                                    <strong>Pickup/Linehaul delivered</strong>
                                    <input type="checkbox" v-model="bookingCopy.pickupAndLinehaulDelivered">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                        <div>
                            <div>
                                <label for="booking-copy-dropoff-date">
                                    <strong>Dropoff date</strong>
                                </label>
                            </div>
                            <div style="display:inline-block; width:200px;">
                                <div
                                    class="rounded-lg div-focus border border-2">
                                    <date-picker
                                        manual-input
                                        v-model="bookingCopy.dropoffDate"
                                        valueType="format"
                                        input-class="border-0 py-0 ml-0 shadow-none form-input"
                                        placeholder="date"
                                        :lang="datePickerOptions.lang"
                                        format="DD-MM-YYYY"
                                        id="booking-copy-dropoff-date"
                                        :clearable="false"
                                        :disabled-date="disabledDates"
                                    >
                                    </date-picker>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-success" @click="copyBooking">
                            Copy
                        </button>
                        <button class="btn btn-primary" @click="toggleModalCopyBooking">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalCopyBooking" class="modal-backdrop fade show"></div>

        <div
            ref="modalForceSms"
            class="modal fade"
            :class="{show, 'd-block': activeModalChangePrice}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Prices will be changed</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModalChangePrice"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <div>
                                <strong>Product price:</strong> {{ booking.product_price }} -->
                                {{ changePriceValues && changePriceValues.productPrice ? changePriceValues.productPrice : 0 }}
                            </div>
                        </div>
                        <div v-if="booking.services_data.length">
                            <div><strong>Service(s) price:</strong></div>
                            <div v-for="s in booking.services_data">
                                {{ s.name }}: {{ s.price }} -->
                                {{ changePriceValues ? changePriceValues.servicePrices[s.id] : 0 }}
                            </div>
                        </div>
                        <div v-if="booking.agreement_insurances_id">
                            <div>
                                <strong>Insurance price:</strong> {{ booking.insurances_price }} -->
                                {{ changePriceValues && changePriceValues.insurancesPrices ? changePriceValues.insurancesPrices : 0 }}
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-success" @click="setPrices">
                            Continue
                        </button>
                        <button class="btn btn-success" @click="continueWithPrice">
                            Continue with current price
                        </button>
                        <button class="btn btn-primary"
                                @click="toggleModalChangePrice"
                                v-if="changePriceModalTriggerredUponAddingColli"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalChangePrice" class="modal-backdrop fade show"></div>

        <loading :active.sync="loading"
                 :can-cancel="false"
                 :is-full-page="true">
        </loading>
    </div>
</template>

<script>
import driverMixin from '../mixins/driverMixin';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';
import datePickerOptionsMixin from "../mixins/datePickerOptionsMixin";
import smsMixin from "../mixins/smsMixin";
import Loading from "vue-loading-overlay";
import priceMixin from "../mixins/priceMixin";
import dateTimeMixin from "../mixins/dateTimeMixin";
import moment from "moment";
import modalMixin from "../mixins/modalMixin";

export default {
    name: "BookingEdit",
    mixins: [driverMixin, datePickerOptionsMixin, smsMixin, priceMixin, dateTimeMixin, modalMixin],
    components: {Loading, DatePicker, VueTimepicker},
    props: {
        url: {type: String, required: true},
        backUrl: {type: String, required: true},
        role: {type: String, required: true},
        roleUser: {type: String, required: true},
        newDeliveryDateKey: {type: String, required: true},
        newPickupDateKey: {type: String, required: true},
        permitsKey: {type: String, required: true},
        shorterTimeIntervalKey: {type: String, required: true},
        insuranceKey: {type: String, required: true},
        primeKey: {type: String, required: true},
        logActionCustomerChangedOptions: {type: String, required: true},
        logActionUpdated: {type: String, required: true},
        availablePermits: {type: Array, required: true},
        smsTemplates: {type: Array, required: true},
        paymentStatuses: {type: Object, required: true},
        types: {type: Object, required: true},
        maxIntervalExceeded: {type: Boolean, required: true},
        userTypeClient: {type: String, required: true},
        sendToDropoff: {type: Number, required: true},
        fileTypeImage: {type: String, required: true},
        fileTypeSignature: {type: String, required: true},
        tripStatusFailed: {type: Number, required: true},
        specialPermissions: {type: Array|Object, default: []},
        driverTypeExternal: {type: Number, required: true},
    },
    data() {
        return {
            countryList: {},
            validationErrors: '',
            vat: 0.25,
            isEditingPickup: false,
            isEditingDropoff: false,
            isEditingNote: false,
            isEditingColli: false,
            isEditingProduct: false,
            isEditingContact: false,
            isEditingStatus: false,
            isEditingTrip: false,
            isEditingExternalDriver: false,
            activeModalInterval: false,
            activeModalIntervalLog: false,
            activeModalIntervalSmsLog: false,
            activeModalIntervalType: false,
            activeModalCopyBooking: false,
            activeModalMessage: false,
            activeModalForceSms: false,
            activeModalChangePrice: false,
            modalOpen: false,
            show: false,
            dropoffDate: {date: this.predefinedTripData()},
            deliveredDate: {
                pickupDate: null,
                dropoffDate: null,
                linehaulDate: this.predefinedTripData(),
            },
            booking: {
                product_time_units_initial: 0,
                service_time_units_initial: 0,
                agreement_id: 0,
                dropoff_address: {country: {name: 'Denmark'}},
                pickup_address: {country: {name: 'Denmark'}},
                product: '',
                pickup_trip: '',
                dropoff_trip: '',
                linehaul_trip: '',
                client_data: {'primary_contact': ''},
                services_data: {},
                colli_data: {},
                new_services: [],
                driver: {},
            },
            clientColliList: {},
            showClientColliList: false,
            colli_deleted: [
                {id: ''},
            ],
            colli: {
                'id': '',
                'reference': '',
                'name': '',
                'colli': '',
                'height': '',
                'width': '',
                'measure': '',
                'volume': '',
                'weight': '',
                'totalVolume': '',
                'totalWeight': '',
                'isExisting': 0
            },
            existingColli: {},
            referenceExistsMessage: '',
            services: {},
            serviceIds: [],
            isSubmit: false,
            logData: {},
            smsLogData: {},
            communicationLog: {},
            loading: false,
            bookingPermits: [],
            insuranceInCustomerOptions: false,
            warningMessage: '',
            selectedSmsTemplate: {},
            bookingCopy: {
                dropoffDate: '',
                pickupDate: '',
                pickupAndLinehaulDelivered: false
            },
            changePriceMessage: '',
            changePriceValues: '',
            changePriceModalTriggerredUponAddingColli: false,
            canEdit: false,
            canDelete: false,
            excludeFromDriverCostReport: false,
        }
    },
    methods: {
        validation() {
            this.isSubmit = true;
        },
        async updateBooking() {
            this.booking.new_services = this.serviceIds;
            this.booking.delivered_date = this.deliveredDate;
            axios.patch(`/bookings/${this.booking.id}`, this.booking).then((response) => {
                window.location.reload();
            }).catch(e => {
                this.validationErrors = e.response.data.errors
            })
        },
        confirmBooking() {
            axios.post(`/booking-confirm/${this.booking.id}`).then((response) => {
                window.location.reload();
            }).catch(err => console.log(err))
        },
        deleteBooking() {
            if (confirm("Are you sure you want to delete this booking?")) {
                axios.delete(`/bookings/${this.booking.id}`).then((response) => {
                    window.location.href = `/bookings`;
                }).catch(error => {
                    this.flashMessage.error({
                        title: '',
                        message: error.response.data.message,
                        time: 2000,
                        blockClass: 'flash-message error'
                    });
                    console.log(error.response)
                });
            }
        },
        fetchData() {
            let dataFetchUrl = `${this.url}`
            axios.get(dataFetchUrl)
                .then(({data}) => {
                    this.booking = data.data;
                    this.booking.colliDataChanged = false;
                    this.booking.colliBatchNumberChanged = false;
                    this.booking.product_time_units_initial = data.data.product_time_units;
                    if (data.data.product_time_units === 0) {
                        this.booking.product_price_per_unit = data.data.product_price;
                    } else {
                        this.booking.product_price_per_unit = data.data.product_price / data.data.product_time_units;
                    }
                    this.excludeFromDriverCostReport = this.booking.cost_price === 0 && this.booking.cost_price_edited;
                    this.analyzeCustomerOptions();
                    this.checkMaxInterval();
                    axios.get(`/service-list/${this.booking.agreement_id}`, {params: {userType: this.userTypeClient}})
                        .then(({data}) => {
                            this.services = data.data;
                            Object.entries(this.booking.services_data).forEach(entry => {
                                const [key, value] = entry;
                                this.serviceIds.push(value.id)
                            });
                        }).catch(error => this.services = [])
                    axios.get(`/colli-list?bookingId=${this.booking.id}&groupByColliBatch=true&isForBookingEdit=true`)
                        .then(({data}) => {
                            this.booking.colli_data = data.data;
                        }).catch()
                    if (this.role !== 'user') {
                        axios.get(`/communication-log/${this.booking.id}`)
                            .then(({data}) => {
                                this.communicationLog = data.result;
                            }).catch()

                        this.fetchDriverList(true);
                    }

                    this.canEdit = this.role !== 'user';
                    if (!this.canEdit && this.booking.status_id < 9) {
                        this.canEdit = true;
                        if (this.booking.trips) {
                            this.booking.trips.forEach((trip) => {
                                if (trip.optimoroute_result && trip.optimoroute_result.includes('Transferred:')) {
                                    this.canEdit = false;
                                }

                            });
                        }
                    }

                    // Delete permission: admins always can, clients can until sent to OptimoRoute
                    if (this.role === 'user') {
                        this.canDelete = true;
                        if (this.booking.trips) {
                            this.booking.trips.forEach((trip) => {
                                if (trip.optimoroute_result && trip.optimoroute_result.includes('Transferred:')) {
                                    this.canDelete = false;
                                }
                            });
                        }
                    } else {
                        this.canDelete = true;
                    }
                }).catch(error => this.booking = []);

            axios.get(`/country-list`)
                .then(({data}) => {
                    this.countryList = data.result;
                }).catch()
        },
        fetchDriverList(onInit) {
            if (!onInit) {
                this.booking.driver = {}
            }
            this.getDriverList(this.driverTypeExternal);
            if (this.driverList.length > 0) {
                this.booking.driver = {'id': this.driverList[1].id, 'name': this.driverList[1].name}
            }
        },
        scrollToElement(options, elementToScroll) {
            const el = this.$el.getElementsByClassName(elementToScroll)[0];
            if (el) {
                el.scrollIntoView(options);
            }
        },
        deleteColli(k, isExisting, id) {
            if (typeof (isExisting) === 'undefined') {
                this.colli_deleted.push({'id': id});
            }
            this.booking.colli_deleted = this.colli_deleted;
            this.booking.colli_data = this.booking.colli_data.filter((x, i) => i !== k);
            this.recalculateCollis();
        },
        getClientColliList() {
            axios.get(`/colli-list?clientIdSingle=${this.booking.client_data.id}&groupByColliBatch=true&excludeDelivered=true&excludeAssigned=true`)
                .then(({data}) => {
                    this.clientColliList = data.data;
                    this.showClientColliList = true;
                }).catch(error => this.clientColliList = [])
        },
        resetColli() {
            this.colli = {
                'id': '',
                'reference': '',
                'name': '',
                'colli': '',
                'height': '',
                'width': '',
                'measure': '',
                'volume': '',
                'weight': '',
                'totalVolume': '',
                'totalWeight': '',
                'isExisting': 0
            }
        },
        async addExistingColli(id) {
            let existingColliData = this.clientColliList.filter(p => p.id == id)[0];

            const totalVolume = parseFloat(this.booking.volume) + parseFloat(existingColliData.totalVolume);
            const totalWeight = parseFloat(this.booking.weight) + parseFloat(existingColliData.totalWeight);
            this.changePriceModalTriggerredUponAddingColli = true;

            this.resetColli();
            this.existingColli = {
                id: id,
                reference: existingColliData.reference,
                name: existingColliData.name,
                colli: existingColliData.colli,
                totalColliAmountByColliBatch: existingColliData.colli,
                height: existingColliData.height,
                width: existingColliData.width,
                totalVolume: existingColliData.totalVolume,
                totalWeight: existingColliData.totalWeight,
                isExisting: 1,
                isFromWarehouseList: 1,
                location: existingColliData.location
            };
            const res = await this.calculatePrice(totalVolume, totalWeight);

            if (res) {
                this.pushColli(this.existingColli);
                this.clientColliList = this.clientColliList.filter(p => p.id !== id);
            }
        },
        async addColli() {
            this.existingColli = {};
            if (this.colli.reference !== '' &&
                this.colli.name !== '' &&
                this.colli.colli !== '' &&
                this.colli.volume !== '' &&
                this.colli.weight !== ''
            ) {
                const totalVolume = parseFloat(this.booking.volume) + parseFloat(this.colli.volume);
                const totalWeight = parseFloat(this.booking.weight) + parseFloat(this.colli.weight);
                this.changePriceModalTriggerredUponAddingColli = true;
                const res = await this.calculatePrice(totalVolume, totalWeight);

                if (res) {
                    this.colli.location = null;
                    this.colli.isExisting = 0;
                    const newColli = {
                        reference: this.colli.reference,
                        name: this.colli.name,
                        colli: this.colli.colli,
                        totalColliAmountByColliBatch: this.colli.colli,
                        height: this.colli.height,
                        width: this.colli.width,
                        measure: this.colli.measure,
                        totalVolume: this.colli.volume,
                        totalWeight: this.colli.weight,
                        location: null,
                        isExisting: 0,
                    };
                    this.pushColli(newColli);
                }
            }
        },
        pushColli(newColli = null) {
            if (!newColli) {
                newColli = this.colli.reference ?
                    {
                        reference: this.colli.reference,
                        name: this.colli.name,
                        colli: this.colli.colli,
                        totalColliAmountByColliBatch: this.colli.colli,
                        height: this.colli.height,
                        width: this.colli.width,
                        measure: this.colli.measure,
                        totalVolume: this.colli.volume,
                        totalWeight: this.colli.weight,
                        location: null,
                        isExisting: 0,
                    } :
                    this.existingColli;
            }
            this.booking.colli_data.push(newColli);
            this.booking.volume = parseFloat(this.booking.volume) + parseFloat(newColli.totalVolume);
            this.booking.weight = parseFloat(this.booking.weight) + parseFloat(newColli.totalWeight);
            this.booking.colli = parseInt(this.booking.colli) + parseInt(newColli.totalColliAmountByColliBatch);
            this.booking.colliDataChanged = true;
        },
        recalculateCollis(e = '', recalculatePrice = true) {
            this.booking.volume = 0;
            this.booking.weight = 0;
            this.booking.colli = 0;
            this.booking.colliDataChanged = true;
            let colliAmount;
            this.booking.colli_data.forEach((colli) => {
                colliAmount = colli.totalColliAmountByColliBatch !== undefined ?
                    colli.totalColliAmountByColliBatch :
                    colli.colli;
                this.booking.volume = this.booking.volume + parseFloat(colli.totalVolume);
                this.booking.weight = this.booking.weight + parseFloat(colli.totalWeight);
                this.booking.colli = this.booking.colli + parseInt(colliAmount);
            });
            if (recalculatePrice) {
                this.changePriceModalTriggerredUponAddingColli = false;
                setTimeout(() => {
                    this.calculatePrice(this.booking.volume, this.booking.weight);
                }, 100);
            }
        },
        calculatePrice(totalVolume, totalWeight) {
            this.changePriceValues = null;
            return new Promise((resolve) => {
                axios.get(`/recalculate-prices-for-booking/${this.booking.id}`, {
                    params:
                        {totalVolume: totalVolume, totalWeight: totalWeight}
                }).then((response) => {
                    console.log(response.data);
                    if (response.data.priceChanged) {
                        this.changePriceValues = response.data.prices;
                        this.toggleModalChangePrice();
                        resolve(false);
                    } else {
                        resolve(true);
                    }

                }).catch((error) => {
                    this.flashMessage.error({
                        title: '',
                        message: error.response.data.message,
                        time: 2000,
                        blockClass: 'flash-message error'
                    });
                    console.log(error.response.data);
                    resolve(false);
                });
            });
        },
        setPrices() {
            let price;
            price = this.changePriceValues.productPrice ?
                parseFloat(this.changePriceValues.productPrice) :
                0;
            this.$set(this.booking, 'product_price', price);

            if (this.booking.agreement_insurances_id) {
                price = this.changePriceValues.insurancesPrices ?
                    parseFloat(this.changePriceValues.insurancesPrices) :
                    0;
                this.$set(this.booking, 'insurances_price', price);
            }

            if (this.booking.services_data.length) {
                for (let i = 0; i < this.booking.services_data.length; i++) {
                    price = parseFloat(this.changePriceValues.servicePrices[this.booking.services_data[i].id]);
                    this.$set(this.booking.services_data[i], 'price', price);
                }
                this.$set(this.booking, 'total_service_price', this.changePriceValues.totalServicePrice);
            }

            this.continueWithPrice();
        },
        continueWithPrice() {
            if (this.changePriceModalTriggerredUponAddingColli) {
                this.pushColli();
            }
            this.toggleModalChangePrice();
        },
        findColliByReference(event) {
            this.clientColliList = {};
            axios.get(`/colli-list?searchByReference=${event.target.value}&clientIdSingle=${this.booking.client_data.id}&groupByColliBatch=true&excludeDelivered=true&excludeAssigned=true`)
                .then(({data}) => {
                    this.clientColliList = data.data;
                }).catch()
        },
        addSingleColliToBatch(batchId) {
            let colliData = this.booking.colli_data.filter(p => p.colli_batch == batchId)[0];
            if (!colliData.totalColliAmountByColliBatch) {
                colliData.totalColliAmountByColliBatch = colliData.colli;
            }
            colliData.totalColliAmountByColliBatch = parseInt(colliData.totalColliAmountByColliBatch) + 1;
            this.booking.colliBatchNumberChanged = true;
            this.recalculateCollis('', false);
        },
        removeSingleColliFromBatch(batchId) {
            let colliData = this.booking.colli_data.filter(p => p.colli_batch == batchId)[0];
            if (colliData.totalColliAmountByColliBatch > 1) {
                colliData.totalColliAmountByColliBatch -= 1;
                this.booking.colliBatchNumberChanged = true;
                this.recalculateCollis('', false);
            }
        },
        setTripDelivered(id, type) {
            if (this.booking.status_id < 2) {
                alert('Please confirm booking before handling trips');

            } else {
                axios.post(`/set-trip-delivered/${id}`).then(() => {
                    if (
                        (
                            this.booking.dropoff_trip &&
                            this.booking.dropoff_date === null &&
                            this.booking.dropoff_trip.status < 2
                        ) &&
                        ((type === 1 && !this.booking.linehaul_trip) || type === 2)
                    ) {
                        this.toggleModal();
                    } else {
                        window.location.reload();
                    }
                }).catch((error) => {
                    console.log(error.response.data);
                    this.flashMessage.error({
                        title: '',
                        message: error.response.data.message || error.response.data || 'Error',
                        time: 2000,
                        blockClass: 'flash-message error'
                    });
                });
            }
        },
        setTripRejected(id, date = null) {

            if (this.booking.status_id < 2) {
                alert('Please confirm booking before handling trips');

            } else {
                const url = date ? `/set-trip-rejected/${id}/${date}` : `/set-trip-rejected/${id}`;
                axios.post(url).then(() => {
                    window.location.reload();
                }).catch((error) => {
                    console.log(error.response.data);
                    this.flashMessage.error({
                        title: '',
                        message: error.response.data.message || error.response.data || 'Error',
                        time: 2000,
                        blockClass: 'flash-message error'
                    });
                });
            }
        },
        addDropoffDate() {
            if (this.dropoffDate.date !== null) {
                axios.post(`/update-dropoff-date/${this.booking.dropoff_trip.id}/${this.dropoffDate.date}`)
                    .then(({data}) => {
                        if (this.modalOpen) {
                            window.location.reload();
                        } else {
                            window.location.reload();
                        }
                    }).catch((error) => {
                    console.log(error.response.data);
                    this.flashMessage.error({
                        title: '',
                        message: error.response.data.message || error.response.data || 'Error',
                        time: 2000,
                        blockClass: 'flash-message error'
                    });
                });
            }
        },
        predefinedTripData(isForDelivered = 0) {
            const currentDate = new Date();
            if (isForDelivered === 1) {
                return currentDate.getDate().toLocaleString('en-US', {minimumIntegerDigits: 2})
                    + '-' + (currentDate.getMonth() + 1).toLocaleString('en-US', {minimumIntegerDigits: 2})
                    + '-' + currentDate.getFullYear();
            }
            const weekDays = 2;
            //exclude weekend days
            for (let i = 1; i <= weekDays; i++) {
                currentDate.setDate(currentDate.getDate() + 1);
                if (currentDate.getDay() === 6) {
                    currentDate.setDate(currentDate.getDate() + 2);
                } else if (currentDate.getDay() === 0) {
                    currentDate.setDate(currentDate.getDate() + 1);
                }
            }
            return currentDate.getDate().toLocaleString('en-US', {minimumIntegerDigits: 2})
                + '-' + (currentDate.getMonth() + 1).toLocaleString('en-US', {minimumIntegerDigits: 2})
                + '-' + currentDate.getFullYear();
        },
        onChangeServiceId(event) {
            let value = parseInt(event.target.value);
            let index = this.serviceIds.indexOf(value);
            if (index !== -1) {
                this.serviceIds.splice(index, 1);
            } else {
                this.serviceIds.push(value)
            }
        },
        toggleModal() {
            this.modalOpen = true;
            this.modalToggle('activeModalInterval');
        },
        toggleModalLog(id) {
            this.logData = this.booking.logs.filter(p => p.id == id)[0];
            this.modalToggle('activeModalIntervalLog');
        },
        toggleModalSmsLog(id) {
            this.smsLogData = this.booking.smsLogs.filter(p => p.id == id)[0];
            this.modalToggle('activeModalIntervalSmsLog');
        },
        toggleModalType(id) {
            this.modalToggle('activeModalIntervalType');
        },
        toggleModalMessage() {
            this.modalToggle('activeModalMessage');
        },
        toggleModalForceSms() {
            this.modalToggle('activeModalForceSms');
        },
        toggleModalCopyBooking() {
            this.modalToggle('activeModalCopyBooking');
        },
        toggleModalChangePrice() {
            this.modalToggle('activeModalChangePrice');
        },
        getImageArray(imageString) {
            return imageString ? imageString.split(',').map(img => img.trim()) : [];
        },
        downloadPod(image, id, type, index = 0) {
            axios({
                url: `/optimoroute/download-pod/${id}/${type}/${index}`,
                method: 'POST',
                responseType: 'blob',
                data: image
            }).then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', image);
                document.body.appendChild(link);
                link.click();
            }); // @todo catch error
        },
        downloadCompletePod(id) {
            if (this.loading) {
                return;
            }
            this.loading = true;
            axios({
                url: `/optimoroute/download-complete-pod/${id}`,
                method: 'POST',
                responseType: 'blob'
            }).then(response => {
                console.log(response);
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${id}.pdf`);
                document.body.appendChild(link);
                link.click();
            }).finally(() => {
                this.loading = false;
            });
        },
        recalculateTimeUnitsProduct(event, id, time_unit_old) {
            const productUnit = parseFloat(event.target.value);
            if (productUnit > 0) {
                if (time_unit_old > 0) {
                    this.booking.product_price = parseFloat(productUnit * this.booking.product_price / time_unit_old).toFixed(2);
                }
                this.booking.product_time_units = productUnit;
            } else if (productUnit === 0) {
                this.booking.product_time_units = 0;
            }
        },
        recalculateTimeUnitsService(event, id, time_unit_old) {
            const serviceUnit = parseFloat(event.target.value);
            if (serviceUnit > 0) {
                let serviceDataEditable = this.booking.services_data.filter(p => p.id == id);
                if (time_unit_old > 0) {
                    serviceDataEditable[0].price = parseFloat(serviceUnit * serviceDataEditable[0].price / time_unit_old).toFixed(2);
                }
                serviceDataEditable[0].time_unit = serviceUnit;
            } else if (serviceUnit === 0) {
                let serviceDataEditable = this.booking.services_data.filter(p => p.id == id);
                serviceDataEditable[0].time_unit = 0;
            }
        },
        redirectToCreateRebookingPage() {
            window.location.href = `/bookings/${this.booking.id}/create-rebooking`;
        },
        changeBookingTypeModal() {
            this.modalOpen = true;
            this.modalToggle('activeModalIntervalType');
        },
        changeBookingType() {
            if (this.booking.booking_type === 1) {
                this.booking.booking_type = 2
            } else {
                this.booking.booking_type = 1;
                this.booking.cost_price = 0;
            }
            this.toggleModalType();
        },
        smsSend(smsTemplate, force = false) {
            const address = smsTemplate.send_to === this.sendToDropoff ? 'dropoff_address' : 'pickup_address'
            this.selectedSmsTemplate = {};

            console.log(address);
            console.log(this.booking[address].phone);
            if (this.booking.is_delivery_from_warehouse) {
                this.flashMessage.error({
                    title: '',
                    message: 'Booking is delivered from warehouse',
                    time: 2000,
                    blockClass: 'flash-message error'
                });
                return;

            } else if (!this.booking[address].phone) {
                this.flashMessage.error({
                    title: '',
                    message: `The phone is missing in ${address}`,
                    time: 2000,
                    blockClass: 'flash-message error'
                });
                return;
            }

            this.selectedSmsTemplate = smsTemplate;

            this.sendSms(smsTemplate.id, [{
                bookingId: this.booking.id,
                customerName: this.booking[address].name,
                phone: this.booking[address].phone
            }], force)
                .then((result) => {
                    if (result.errors[this.booking.id] &&
                        result.errors[this.booking.id] === `Sms ${smsTemplate.id} has already been sent for the booking ${this.booking.id}`
                    ) {
                        this.toggleModalForceSms();
                    }
                });
        },
        analyzeCustomerOptions() {
            if (this.booking.customerOptions.length) {
                for (let i = 0; i < this.booking.customerOptions.length; i++) {
                    if (undefined !== this.booking.customerOptions[i].options[this.permitsKey] &&
                        this.booking.customerOptions[i].options[this.permitsKey].enabled
                    ) {
                        this.bookingPermits.push(this.booking.customerOptions[i].options[this.permitsKey].name)
                    }

                    if (undefined !== this.booking.customerOptions[i].options[this.insuranceKey] &&
                        this.booking.customerOptions[i].options[this.insuranceKey].enabled
                    ) {
                        this.insuranceInCustomerOptions = true;
                    }
                }
            }
        },
        calcTotalExclVat() {
            let total = this.booking.total_service_price + parseFloat(this.booking.product_price);
            if (!this.insuranceInCustomerOptions) {
                total += parseFloat(this.booking.insurances_price);
            }
            return total;
        },
        calcTotalExclVatForUpgrade(options) {
            let total = 0;
            for (let key in options) {
                if (key === this.primeKey) {
                    for (let k in options[key]) {
                        if (typeof (options[key][k]) === 'object' && options[key][k].enabled) {
                            total += parseFloat(options[key][k].price);
                        }
                    }
                } else if (options[key].enabled) {
                    total += parseFloat(options[key].price);
                }
            }
            return total;
        },
        calcTotalForLog(data) {
            let price = 0;
            let totalPrice = 0;
            for (let key in data) {
                if (data[key].key === this.primeKey) {
                    for (let i in data[key]) {
                        if (typeof data[key][i] === 'object') {
                            price = data[key][i].price ? data[key][i].price : 0;
                            price = this.calculatePriceWithVatAndRoundToNearestTens(price);
                        }
                    }
                } else {
                    price = (data[key].price ? data[key].price : 0);
                    price = this.calculatePriceWithVatAndRoundToNearestTens(price);
                }
                totalPrice += price;
            }

            return totalPrice;
        },
        checkMaxInterval() {
            if (this.maxIntervalExceeded && !this.booking.total_price) {
                this.warningMessage = 'Volume/weight of colli exceeds the max interval, so price has been set to 0.' +
                    ' Please adjust the price accordingly.'
                this.toggleModalMessage();
            }
        },
        goBack() {
            sessionStorage.setItem('applyBookingsSearchString', '1');
            window.location.href = this.backUrl;
        },
        copyBooking() {
            axios.post(`/bookings/${this.booking.id}/copy`, this.bookingCopy)
                .then((response) => {
                    console.log(response.data);
                    this.flashMessage.success({
                        title: '',
                        message: `The booking has been copied successfully`,
                        time: 2000,
                        blockClass: 'flash-message'
                    });
                    this.toggleModalCopyBooking();
                }).catch((error) => {
                console.log(error.response);
                this.flashMessage.error({
                    title: '',
                    message: error.response.data.message || error.response.data || 'Error',
                    time: 2000,
                    blockClass: 'flash-message error'
                });
            });
        },
        disabledDates(date) {
            const startFrom = moment().toDate();
            startFrom.setHours(0, 0, 0, 0);

            return date < startFrom;
        },
        hasSpecialPermission(permission) {
            return this.specialPermissions?.[permission] === true;
        },
        tripCanBeMarkedAsForeign(trip, address) {
            return address.country.name !== 'Denmark';
        },
        onChangeExcludeFromDriverCostReport() {
            if (this.excludeFromDriverCostReport) {
                this.$set(this.booking, 'cost_price', 0);
                this.$set(this.booking, 'cost_price_edited', 1);
            }
        }
    },
    created() {
        this.fetchData();
        let future2BusinessDays = moment().add(2, 'days');
        while (['Saturday', 'Sunday'].includes(future2BusinessDays.format('dddd'))) {
            future2BusinessDays = future2BusinessDays.add(1, 'days');
        }
        setTimeout(() => {
            this.$set(this.bookingCopy, 'dropoffDate', future2BusinessDays.format('DD-MM-YYYY'));
            this.$set(this.bookingCopy, 'pickupDate', future2BusinessDays.format('DD-MM-YYYY'));
        }, 10);
    },
}
</script>
<style>
.status-block {
    width: 165px;
    height: 56px;
    background: rgba(89, 165, 145, 0.16);
    border-radius: 8px;
}

.status-block-inactive {
    width: 165px;
    height: 56px;
    background: #F9F9F9;
    border-radius: 8px;
}

.status-text {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.02em;
    color: #59A591;
}

.status-text-inactive {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.02em;
    color: #777777;
}

.border-bottom-status {
    border-bottom: 4px solid #59A591 !important;
}

span.status-label {
    margin-left: 10px;
}

.status-icons {
    display: block !important;
}

.fixed-height-500 {
    min-height: 500px;
}

.action-block {
    margin-top: 20px;
}

.confirm-button {
    margin-left: 10px;
}

.colli-number {
    position: relative;
    bottom: 6px;
}

.trip-actions {
    display: inline-block;
    width: 150px;
}

.pod-button {
    margin-bottom: 5px;
}

.rebooking {
    font-style: italic;
    font-size: 10px;
}

.status-block-error {
    background-color: red;
    opacity: 70%;
}
</style>
